// Auto-generated by /app/scripts/build_i18n.py
export const QUESTIONS = [
 {
  "id": 1,
  "category": "c-core",
  "q": "On a typical platform with 4-byte int, what does printf(\"%zu\", sizeof('A')); print in C?",
  "options": [
   "1",
   "4",
   "2",
   "Compilation error"
  ],
  "correctIndex": 1,
  "explanation": "In C a character constant has type int, so sizeof('A') equals sizeof(int), typically 4 (it would be 1 in C++)."
 },
 {
  "id": 2,
  "category": "c-core",
  "q": "What is the result of: int a = 5; printf(\"%d\", a++ + ++a);",
  "options": [
   "12",
   "11",
   "10",
   "Undefined behavior"
  ],
  "correctIndex": 3,
  "explanation": "Modifying a twice between sequence points without sequencing is undefined behavior, so no value is guaranteed."
 },
 {
  "id": 3,
  "category": "c-core",
  "q": "What happens here? char *s = \"hello\"; s[0] = 'H'; printf(\"%s\", s);",
  "options": [
   "Prints Hello",
   "Prints hello",
   "Compile-time error",
   "Undefined behavior (modifying a string literal)"
  ],
  "correctIndex": 3,
  "explanation": "String literals may live in read-only memory, so modifying one is undefined behavior and often crashes."
 },
 {
  "id": 4,
  "category": "c-core",
  "q": "Output of: int a[]={10,20,30}; int *p=a; printf(\"%d\", *p++); printf(\" %d\", *p);",
  "options": [
   "10 20",
   "20 20",
   "10 10",
   "11 20"
  ],
  "correctIndex": 0,
  "explanation": "*p++ yields 10 (post-increment moves the pointer afterward), so *p is then 20."
 },
 {
  "id": 5,
  "category": "c-core",
  "q": "What is printed by: printf(\"%.1f\", 7/2*2.0);",
  "options": [
   "7.0",
   "3.0",
   "7.5",
   "6.0"
  ],
  "correctIndex": 3,
  "explanation": "7/2 is integer division giving 3; 3*2.0 = 6.0."
 },
 {
  "id": 6,
  "category": "c-core",
  "q": "Output of calling f() three times? void f(){ static int c=0; c++; printf(\"%d \", c); }",
  "options": [
   "1 1 1",
   "0 1 2",
   "1 2 3",
   "Undefined"
  ],
  "correctIndex": 2,
  "explanation": "A static local is initialized once and keeps its value between calls, so it prints 1 2 3."
 },
 {
  "id": 7,
  "category": "c-core",
  "q": "Given #define SQ(x) x*x, what does printf(\"%d\", SQ(2+3)); print?",
  "options": [
   "25",
   "11",
   "10",
   "Compilation error"
  ],
  "correctIndex": 1,
  "explanation": "The macro expands textually to 2+3*2+3 = 11, which is why macro arguments should be parenthesized."
 },
 {
  "id": 8,
  "category": "c-core",
  "q": "What does int i = 3; printf(\"%d\", i << 1 + 1); print?",
  "options": [
   "7",
   "6",
   "12",
   "8"
  ],
  "correctIndex": 2,
  "explanation": "+ has higher precedence than <<, so it is 3 << 2 = 12."
 },
 {
  "id": 9,
  "category": "c-core",
  "q": "Output of: unsigned char c = 255; c++; printf(\"%d\", c);",
  "options": [
   "256",
   "-1",
   "255",
   "0"
  ],
  "correctIndex": 3,
  "explanation": "Unsigned arithmetic wraps modulo 256, so 255 + 1 becomes 0."
 },
 {
  "id": 10,
  "category": "c-core",
  "q": "In void f(int a[10]){ printf(\"%zu\", sizeof(a)); } on a 64-bit system, what is printed?",
  "options": [
   "40",
   "Size of a pointer (8)",
   "10",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "An array parameter decays to int*, so sizeof gives the pointer size, not the array size."
 },
 {
  "id": 11,
  "category": "c-core",
  "q": "Which declaration lets you change the pointed-to value through p but not make p point elsewhere?",
  "options": [
   "const int *p",
   "int *const p",
   "const int *const p",
   "int const *p"
  ],
  "correctIndex": 1,
  "explanation": "int *const p is a constant pointer to a modifiable int; the other forms make the pointee read-only."
 },
 {
  "id": 12,
  "category": "c-core",
  "q": "Output of: char s[] = \"abc\"; printf(\"%zu %zu\", sizeof(s), strlen(s));",
  "options": [
   "3 3",
   "4 4",
   "3 4",
   "4 3"
  ],
  "correctIndex": 3,
  "explanation": "sizeof counts the terminating '\\0' (4), whereas strlen does not (3)."
 },
 {
  "id": 13,
  "category": "c-core",
  "q": "Output of: int x=2; switch(x){case 1: printf(\"A\"); case 2: printf(\"B\"); case 3: printf(\"C\"); break; default: printf(\"D\");}",
  "options": [
   "B",
   "BC",
   "BCD",
   "ABC"
  ],
  "correctIndex": 1,
  "explanation": "Execution starts at case 2 and falls through to case 3, where break stops it, printing BC."
 },
 {
  "id": 14,
  "category": "c-core",
  "q": "In C99/C11, what does printf(\"%d\", -7 % 3); print?",
  "options": [
   "-1",
   "1",
   "2",
   "-2"
  ],
  "correctIndex": 0,
  "explanation": "Integer division truncates toward zero, so the remainder takes the sign of the dividend: -7 % 3 = -1."
 },
 {
  "id": 15,
  "category": "c-core",
  "q": "What is wrong with: int* f(){ int x = 5; return &x; }",
  "options": [
   "Nothing, x is kept alive",
   "It returns a dangling pointer to a local variable",
   "It leaks memory",
   "It will not compile"
  ],
  "correctIndex": 1,
  "explanation": "x's lifetime ends when f returns, so dereferencing the returned pointer is undefined behavior."
 },
 {
  "id": 16,
  "category": "c-core",
  "q": "What is the output of: printf(\"%d\", printf(\"Hi\"));",
  "options": [
   "Hi2",
   "2Hi",
   "Hi",
   "Hi0"
  ],
  "correctIndex": 0,
  "explanation": "The inner printf prints Hi and returns 2, which the outer printf then prints."
 },
 {
  "id": 17,
  "category": "c-core",
  "q": "What does int arr[5] = {1, 2}; printf(\"%d\", arr[4]); print?",
  "options": [
   "Garbage value",
   "2",
   "0",
   "Undefined behavior"
  ],
  "correctIndex": 2,
  "explanation": "With a partial initializer list, the remaining elements are zero-initialized."
 },
 {
  "id": 18,
  "category": "c-core",
  "q": "Typical 64-bit sizeof of: union U { int i; double d; char c[9]; };",
  "options": [
   "9",
   "16",
   "8",
   "24"
  ],
  "correctIndex": 1,
  "explanation": "The largest member is 9 bytes, and padding to the 8-byte alignment of double gives 16."
 },
 {
  "id": 19,
  "category": "c-core",
  "q": "What does int i = 0; if (i = 0) printf(\"A\"); else printf(\"B\"); print?",
  "options": [
   "A",
   "AB",
   "B",
   "Compilation error"
  ],
  "correctIndex": 2,
  "explanation": "i = 0 is an assignment whose value is 0 (false), so the else branch prints B."
 },
 {
  "id": 20,
  "category": "c-core",
  "q": "Which C11 feature performs a compile-time assertion, e.g. checking sizeof(int)==4?",
  "options": [
   "assert()",
   "#error only",
   "_Static_assert",
   "static_check"
  ],
  "correctIndex": 2,
  "explanation": "C11 added _Static_assert(condition, message), which is evaluated at compile time, unlike runtime assert()."
 },
 {
  "id": 21,
  "category": "c-core",
  "q": "What does printf(\"%d\", (int)(sizeof(int[10]) / sizeof(int))); print?",
  "options": [
   "40",
   "10",
   "1",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "sizeof(int[10]) is 10 times sizeof(int), so dividing by sizeof(int) gives 10."
 },
 {
  "id": 22,
  "category": "c-core",
  "q": "Output of: int a = 3, b = 4; printf(\"%d\", a & b);",
  "options": [
   "7",
   "12",
   "1",
   "0"
  ],
  "correctIndex": 3,
  "explanation": "3 is 011 and 4 is 100, so they share no set bits and a & b is 0."
 },
 {
  "id": 23,
  "category": "c-core",
  "q": "Output of: char c = 'A' + 2; printf(\"%c %d\", c, c);",
  "options": [
   "C 67",
   "C 65",
   "A 67",
   "B 66"
  ],
  "correctIndex": 0,
  "explanation": "'A' is 65, so 'A'+2 is 67, which is the character 'C'."
 },
 {
  "id": 24,
  "category": "c-core",
  "q": "Output of: for(int i=0;i<5;i++){ if(i==2) continue; if(i==4) break; printf(\"%d\",i); }",
  "options": [
   "0123",
   "013",
   "01234",
   "0134"
  ],
  "correctIndex": 1,
  "explanation": "i=2 is skipped by continue and the loop stops at i=4 before printing, so the output is 0 1 3."
 },
 {
  "id": 25,
  "category": "c-core",
  "q": "What does printf(\"%d\", 5 > 3 > 1); print?",
  "options": [
   "1",
   "0",
   "5",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "5>3 evaluates to 1, and then 1>1 is false, so the result is 0."
 },
 {
  "id": 26,
  "category": "c-core",
  "q": "What does malloc return when it cannot allocate the requested memory?",
  "options": [
   "NULL",
   "A pointer to zero-filled memory",
   "-1",
   "It terminates the program"
  ],
  "correctIndex": 0,
  "explanation": "malloc returns NULL on failure, so callers must check the result."
 },
 {
  "id": 27,
  "category": "c-core",
  "q": "Output of: int x = 1; { int x = 2; } printf(\"%d\", x);",
  "options": [
   "2",
   "1",
   "Compile error: redeclaration",
   "Undefined"
  ],
  "correctIndex": 1,
  "explanation": "The inner x is scoped to the inner block, so the outer x is still 1."
 },
 {
  "id": 28,
  "category": "c-core",
  "q": "What does printf(\"%zu\", strlen(\"a\\0b\")); print?",
  "options": [
   "3",
   "2",
   "1",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "strlen stops at the first null character, which comes after 'a', so it returns 1."
 },
 {
  "id": 29,
  "category": "c-core",
  "q": "Output of: float f = 0.1f; printf(\"%d\", f == 0.1);",
  "options": [
   "1",
   "0",
   "Compile error",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "The float 0.1f is promoted to double and differs from the double 0.1, so the comparison is false (0)."
 },
 {
  "id": 30,
  "category": "c-core",
  "q": "What is the behavior of: int i = 5; i = i++ + 1;",
  "options": [
   "i becomes 6",
   "i becomes 7",
   "Undefined behavior",
   "Compile error"
  ],
  "correctIndex": 2,
  "explanation": "i is modified twice without a sequence point between the modifications, which is undefined behavior."
 },
 {
  "id": 31,
  "category": "c-core",
  "q": "Output of: int a=10; int *p=&a; int **q=&p; **q=20; printf(\"%d\", a);",
  "options": [
   "10",
   "Address of a",
   "Compile error",
   "20"
  ],
  "correctIndex": 3,
  "explanation": "**q dereferences twice to reach a, so assigning through it sets a to 20."
 },
 {
  "id": 32,
  "category": "c-core",
  "q": "Output of: enum {A, B=5, C}; printf(\"%d\", C);",
  "options": [
   "2",
   "5",
   "6",
   "7"
  ],
  "correctIndex": 2,
  "explanation": "Enumerators without an explicit value take the previous value plus one, so C is 6."
 },
 {
  "id": 33,
  "category": "c-core",
  "q": "What does printf(\"%d\", 07 + 010); print?",
  "options": [
   "15",
   "17",
   "8",
   "10"
  ],
  "correctIndex": 0,
  "explanation": "A leading 0 makes a literal octal, so 07 is 7 and 010 is 8, giving 15."
 },
 {
  "id": 34,
  "category": "c-core",
  "q": "What does printf(\"%s\", \"Hello\" + 2); print?",
  "options": [
   "Hello2",
   "He",
   "llo",
   "ello"
  ],
  "correctIndex": 2,
  "explanation": "Adding 2 to the string pointer skips 'H' and 'e', so the output is \"llo\"."
 },
 {
  "id": 35,
  "category": "c-core",
  "q": "Output of: int x = -1; unsigned y = 1; printf(\"%d\", x < y);",
  "options": [
   "1",
   "0",
   "Compile error",
   "Undefined"
  ],
  "correctIndex": 1,
  "explanation": "x is converted to unsigned, becoming UINT_MAX, which is not less than 1, so the result is 0."
 },
 {
  "id": 36,
  "category": "c-core",
  "q": "Which keyword on a file-scope variable gives it internal linkage, so it is visible only within that translation unit?",
  "options": [
   "extern",
   "register",
   "static",
   "volatile"
  ],
  "correctIndex": 2,
  "explanation": "static at file scope restricts the identifier to its translation unit."
 },
 {
  "id": 37,
  "category": "c-core",
  "q": "For int arr[2][3]; on a typical platform with 4-byte int, what does sizeof(arr[0]) give?",
  "options": [
   "4",
   "12",
   "24",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "arr[0] is an array of 3 ints, so its size is 3*4 = 12 bytes."
 },
 {
  "id": 38,
  "category": "c-core",
  "q": "What does printf(\"%d\", !!5); print?",
  "options": [
   "5",
   "0",
   "1",
   "-1"
  ],
  "correctIndex": 2,
  "explanation": "!5 is 0 and !0 is 1, so !!5 normalizes any nonzero value to 1."
 },
 {
  "id": 39,
  "category": "c-core",
  "q": "Output of: int a[3]={1,2,3}; printf(\"%d\", *(a+1) + a[2]);",
  "options": [
   "4",
   "5",
   "6",
   "3"
  ],
  "correctIndex": 1,
  "explanation": "*(a+1) is a[1], which is 2, and a[2] is 3, so the sum is 5."
 },
 {
  "id": 40,
  "category": "c-core",
  "q": "On a typical 64-bit platform, what does printf(\"%d\", sizeof(char*) == sizeof(int*)); print?",
  "options": [
   "0",
   "1",
   "8",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "Object pointers are both 8 bytes on common 64-bit platforms, so the comparison yields 1."
 },
 {
  "id": 41,
  "category": "pointers",
  "q": "On a typical 64-bit system, what does this print?\nvoid f(int a[]) { printf(\"%zu\", sizeof(a)); }\nint main(){ int arr[10]; f(arr); }",
  "options": [
   "40",
   "8",
   "10",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "An array parameter decays to a pointer, so sizeof(a) is the pointer size (8 bytes on 64-bit), not the array size."
 },
 {
  "id": 42,
  "category": "pointers",
  "q": "What is the output?\nint x = 5; int *p = &x; (*p)++; printf(\"%d\", x);",
  "options": [
   "6",
   "5",
   "Address of x",
   "Undefined behavior"
  ],
  "correctIndex": 0,
  "explanation": "(*p)++ increments the value pointed to by p, which is x, so x becomes 6."
 },
 {
  "id": 43,
  "category": "pointers",
  "q": "What is the output?\nint a[] = {1,2,3,4}; int *p = a; printf(\"%d\", *(p+2));",
  "options": [
   "2",
   "4",
   "3",
   "Address of a[2]"
  ],
  "correctIndex": 2,
  "explanation": "p+2 points to a[2], and dereferencing it gives 3."
 },
 {
  "id": 44,
  "category": "pointers",
  "q": "What is the output?\nint a[] = {10,20,30}; int *p = a;\n*p++ += 5;\nprintf(\"%d %d\", a[0], *p);",
  "options": [
   "10 25",
   "15 15",
   "10 20",
   "15 20"
  ],
  "correctIndex": 3,
  "explanation": "*p++ yields the lvalue a[0] and then advances p, so a[0] becomes 15 and *p is now a[1], which is 20."
 },
 {
  "id": 45,
  "category": "pointers",
  "q": "Given int a[5]; int *p = &a[4]; int *q = &a[1]; what is p - q?",
  "options": [
   "12",
   "3",
   "4",
   "Undefined"
  ],
  "correctIndex": 1,
  "explanation": "Pointer subtraction within the same array gives the element count between them: 4 - 1 = 3."
 },
 {
  "id": 46,
  "category": "pointers",
  "q": "What is the problem here?\nint* f(){ int x = 10; return &x; }",
  "options": [
   "Missing cast on return",
   "Functions cannot return pointers",
   "It returns a dangling pointer to a local variable (UB on use)",
   "x is not initialized"
  ],
  "correctIndex": 2,
  "explanation": "x has automatic storage and ceases to exist when f returns, so dereferencing the returned pointer is undefined behavior."
 },
 {
  "id": 47,
  "category": "pointers",
  "q": "Which statement about free() is correct in C11?",
  "options": [
   "free(NULL) is safe and does nothing",
   "free(NULL) crashes the program",
   "free() sets the pointer to NULL automatically",
   "free() can be used on stack arrays"
  ],
  "correctIndex": 0,
  "explanation": "The standard guarantees free(NULL) performs no action; free() never modifies the caller's pointer variable."
 },
 {
  "id": 48,
  "category": "pointers",
  "q": "What happens here?\nchar *p = malloc(10);\np = malloc(20);\nfree(p);",
  "options": [
   "Both blocks are freed",
   "Compile error",
   "Runtime error on second malloc",
   "The first 10-byte block is leaked"
  ],
  "correctIndex": 3,
  "explanation": "The address of the first block is overwritten without being freed, so that memory is leaked."
 },
 {
  "id": 49,
  "category": "pointers",
  "q": "In strict ISO C, what is wrong with this code?\nchar buf[8]; void *p = buf; p++;",
  "options": [
   "Nothing, it always advances by 1 byte",
   "Arithmetic on void* is not allowed (GCC allows it as an extension)",
   "Arrays cannot be assigned to void*",
   "p++ works only on int pointers"
  ],
  "correctIndex": 1,
  "explanation": "void is an incomplete type with no size, so pointer arithmetic on void* violates ISO C, though GCC treats the size as 1."
 },
 {
  "id": 50,
  "category": "pointers",
  "q": "What happens?\nint x = 1, y = 2;\nint *const p = &x;\np = &y;",
  "options": [
   "p now points to y",
   "Undefined behavior at runtime",
   "Compile-time error: assignment to a const pointer",
   "x becomes 2"
  ],
  "correctIndex": 2,
  "explanation": "int *const means the pointer itself is constant, so reassigning p is a compile error (the pointee could still be modified)."
 },
 {
  "id": 51,
  "category": "pointers",
  "q": "What does this code lead to?\nint *p = malloc(sizeof(int));\nfree(p);\nfree(p);",
  "options": [
   "Undefined behavior (double free)",
   "Safe, the second free is ignored",
   "Compile error",
   "Returns an error code from free"
  ],
  "correctIndex": 0,
  "explanation": "Freeing the same pointer twice is undefined behavior and often corrupts the heap or aborts."
 },
 {
  "id": 52,
  "category": "pointers",
  "q": "What is the key difference between calloc(n, size) and malloc(n*size)?",
  "options": [
   "calloc allocates on the stack",
   "calloc cannot be freed",
   "malloc is faster and always zeroes memory",
   "calloc zero-initializes the allocated memory"
  ],
  "correctIndex": 3,
  "explanation": "calloc returns memory with all bits set to zero, while malloc leaves it uninitialized."
 },
 {
  "id": 53,
  "category": "pointers",
  "q": "Which is the safest way to grow a heap buffer pointed to by p?",
  "options": [
   "p = realloc(p, n);",
   "tmp = realloc(p, n); if (tmp) p = tmp;",
   "free(p); p = realloc(p, n);",
   "realloc(p, n); ignoring the return value"
  ],
  "correctIndex": 1,
  "explanation": "If realloc fails it returns NULL and the original block stays valid, so assigning directly to p would leak it."
 },
 {
  "id": 54,
  "category": "pointers",
  "q": "What does this code do?\nchar *s = \"hello\";\ns[0] = 'H';",
  "options": [
   "Changes s to \"Hello\" safely",
   "Compile error always",
   "Undefined behavior: modifying a string literal",
   "Prints Hello"
  ],
  "correctIndex": 2,
  "explanation": "String literals may be stored in read-only memory, so modifying one is undefined behavior; use char s[] = \"hello\" instead."
 },
 {
  "id": 55,
  "category": "pointers",
  "q": "What is the output?\nchar s[] = \"hello\";\nprintf(\"%zu %zu\", sizeof(s), strlen(s));",
  "options": [
   "6 5",
   "5 5",
   "5 6",
   "6 6"
  ],
  "correctIndex": 0,
  "explanation": "sizeof counts the terminating '\\0' (6 bytes), while strlen does not (5)."
 },
 {
  "id": 56,
  "category": "pointers",
  "q": "What is the output?\nint x = 5; int *p = &x; int **q = &p;\n**q = 9;\nprintf(\"%d\", x);",
  "options": [
   "5",
   "Address of p",
   "Compile error",
   "9"
  ],
  "correctIndex": 3,
  "explanation": "**q dereferences twice to reach x, so assigning 9 modifies x."
 },
 {
  "id": 57,
  "category": "pointers",
  "q": "What is the output?\nint a[2][3] = {{1,2,3},{4,5,6}};\nprintf(\"%d\", *(*(a+1)+2));",
  "options": [
   "5",
   "6",
   "3",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "a+1 is row 1, *(a+1)+2 points to element column 2, which is a[1][2] = 6."
 },
 {
  "id": 58,
  "category": "pointers",
  "q": "On a typical platform with 4-byte int and alignment 4, what is sizeof(struct S)?\nstruct S { char c; int i; };",
  "options": [
   "5",
   "4",
   "8",
   "6"
  ],
  "correctIndex": 2,
  "explanation": "3 bytes of padding follow c so that i is aligned, giving a total size of 8."
 },
 {
  "id": 59,
  "category": "pointers",
  "q": "Assuming 4-byte int, what does this print?\nint a[3];\nprintf(\"%td\", (char*)(&a+1) - (char*)a);",
  "options": [
   "12",
   "4",
   "3",
   "1"
  ],
  "correctIndex": 0,
  "explanation": "&a has type int(*)[3], so &a+1 moves past the whole array (12 bytes)."
 },
 {
  "id": 60,
  "category": "pointers",
  "q": "What does the declaration int (*fp)(int); declare?",
  "options": [
   "A function returning int* taking int",
   "An array of function pointers",
   "A pointer to int named fp",
   "A pointer to a function taking int and returning int"
  ],
  "correctIndex": 3,
  "explanation": "The parentheses bind * to fp, so fp is a pointer to a function (int) returning int; without them it would be a function returning int*."
 },
 {
  "id": 61,
  "category": "pointers",
  "q": "What is the output?\nint a[] = {1,2,3,4,5}; int *p = a + 1;\nprintf(\"%d\", p[2]);",
  "options": [
   "3",
   "4",
   "5",
   "2"
  ],
  "correctIndex": 1,
  "explanation": "p points to a[1], so p[2] is a[3], which is 4."
 },
 {
  "id": 62,
  "category": "pointers",
  "q": "On a typical 64-bit system with 4-byte int, what does this print?\nchar *p = \"abc\";\nprintf(\"%zu %zu\", sizeof(p), sizeof(\"abc\"));",
  "options": [
   "4 3",
   "8 3",
   "8 4",
   "4 4"
  ],
  "correctIndex": 2,
  "explanation": "sizeof(p) is the pointer size (8). The literal \"abc\" is a char[4] including '\\0', so its size is 4."
 },
 {
  "id": 63,
  "category": "pointers",
  "q": "What happens when this is compiled?\nvoid *p; int x = 5; p = &x;\nprintf(\"%d\", *p);",
  "options": [
   "Prints 5",
   "Prints garbage",
   "Compile error: cannot dereference void *",
   "Runtime segmentation fault"
  ],
  "correctIndex": 2,
  "explanation": "A void pointer must be cast to a complete object pointer type before it is dereferenced."
 },
 {
  "id": 64,
  "category": "pointers",
  "q": "What is the output?\nint a[2][3];\nprintf(\"%zu %zu\", sizeof(a), sizeof(a[0]));\n(4-byte int)",
  "options": [
   "24 12",
   "24 24",
   "12 12",
   "24 4"
  ],
  "correctIndex": 0,
  "explanation": "The whole array is 6*4 = 24 bytes. a[0] is an int[3], which is 12 bytes."
 },
 {
  "id": 65,
  "category": "pointers",
  "q": "What is the problem with this code?\nint *p = malloc(sizeof(int));\n*p = 7;\nfree(p);\nprintf(\"%d\", *p);",
  "options": [
   "No problem, prints 7 always",
   "Compile error",
   "Memory leak only",
   "Undefined behavior: use after free"
  ],
  "correctIndex": 3,
  "explanation": "Reading memory after free() is a dangling-pointer dereference, which is undefined behavior."
 },
 {
  "id": 66,
  "category": "pointers",
  "q": "What does this declaration mean?\nint (*arr[3])(int);",
  "options": [
   "Pointer to an array of 3 functions",
   "Array of 3 pointers to functions taking int and returning int",
   "Function returning pointer to array of 3 ints",
   "Array of 3 int pointers"
  ],
  "correctIndex": 1,
  "explanation": "[] binds first, so arr is an array of 3 pointers. Each points to a function (int) returning int."
 },
 {
  "id": 67,
  "category": "pointers",
  "q": "What happens?\nint x = 10;\nconst int *p = &x;\n*p = 20;",
  "options": [
   "x becomes 20",
   "Compile error: assignment to read-only location *p",
   "p becomes NULL",
   "Undefined behavior at runtime only"
  ],
  "correctIndex": 1,
  "explanation": "p is a pointer to const int, so writing through *p is a constraint violation. The compiler rejects it."
 },
 {
  "id": 68,
  "category": "pointers",
  "q": "Why is this code undefined behavior?\nfloat f = 1.0f;\nint i = *(int *)&f;",
  "options": [
   "Float and int have different sizes",
   "Casting pointers is always illegal",
   "It violates strict aliasing rules",
   "f is not initialized"
  ],
  "correctIndex": 2,
  "explanation": "Accessing a float object through an int lvalue breaks effective-type (strict aliasing) rules. Use memcpy or a union instead."
 },
 {
  "id": 69,
  "category": "pointers",
  "q": "On a typical 64-bit platform, what is sizeof(struct Node)?\nstruct Node { int v; struct Node *next; };",
  "options": [
   "12",
   "16",
   "8",
   "20"
  ],
  "correctIndex": 1,
  "explanation": "int takes 4 bytes, then 4 bytes of padding align the 8-byte pointer, giving 16."
 },
 {
  "id": 70,
  "category": "pointers",
  "q": "What does this code do?\nint *p;\n*p = 5;",
  "options": [
   "Writes 5 to a random or invalid address (undefined behavior)",
   "Sets p to 5",
   "Allocates memory automatically",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "p is uninitialized (a wild pointer), so dereferencing it is undefined behavior."
 },
 {
  "id": 71,
  "category": "pointers",
  "q": "Which function is guaranteed to work correctly when the source and destination buffers overlap?",
  "options": [
   "memcpy",
   "strcpy",
   "memmove",
   "strncpy"
  ],
  "correctIndex": 2,
  "explanation": "memmove handles overlapping regions. memcpy has undefined behavior on overlap."
 },
 {
  "id": 72,
  "category": "pointers",
  "q": "What is the output?\nchar *p = \"world\";\nprintf(\"%s\", p + 2);",
  "options": [
   "world",
   "orld",
   "rld",
   "ld"
  ],
  "correctIndex": 2,
  "explanation": "p+2 points to the 'r', so printing as a string gives \"rld\"."
 },
 {
  "id": 73,
  "category": "pointers",
  "q": "What happens?\nvoid f(int *p){ p = malloc(sizeof(int)); *p = 5; }\nint main(){ int *q = NULL; f(q); printf(\"%p\", (void*)q); }",
  "options": [
   "q holds the new address, and 5 is stored in it",
   "q remains NULL and the allocated memory leaks",
   "Compile error",
   "q is freed automatically"
  ],
  "correctIndex": 1,
  "explanation": "The pointer is passed by value, so the caller's q is unchanged. The malloc'd block is leaked."
 },
 {
  "id": 74,
  "category": "pointers",
  "q": "What does malloc(0) return in C11?",
  "options": [
   "Always NULL",
   "Always a valid unique non-NULL pointer",
   "Undefined behavior",
   "Implementation-defined: NULL or a unique pointer that must not be dereferenced"
  ],
  "correctIndex": 3,
  "explanation": "The C standard leaves malloc(0) implementation-defined. Either result is valid, and the pointer cannot be dereferenced."
 },
 {
  "id": 75,
  "category": "pointers",
  "q": "What is the output?\nint a[] = {4,5,6}; int *p = &a[0]; int *q = &a[2];\nprintf(\"%d\", (int)(q - p) + *q);",
  "options": [
   "8",
   "2",
   "6",
   "12"
  ],
  "correctIndex": 0,
  "explanation": "q-p is 2 elements, and *q is 6, so the sum is 8."
 },
 {
  "id": 76,
  "category": "c-arrays",
  "q": "What does this print on a typical system?\nint a[5];\nprintf(\"%zu\", sizeof(a)/sizeof(a[0]));",
  "options": [
   "4",
   "5",
   "20",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "sizeof(a) is 5*sizeof(int) and sizeof(a[0]) is sizeof(int), so the ratio is the element count, 5."
 },
 {
  "id": 77,
  "category": "c-arrays",
  "q": "Output?\nchar s[] = \"abc\\0def\";\nprintf(\"%zu %zu\", sizeof(s), strlen(s));",
  "options": [
   "7 3",
   "8 3",
   "8 7",
   "4 3"
  ],
  "correctIndex": 1,
  "explanation": "The literal has 7 characters plus the implicit terminator, so sizeof is 8. strlen stops at the first '\\0', giving 3."
 },
 {
  "id": 78,
  "category": "c-arrays",
  "q": "On a 64-bit system, what is printed?\nvoid f(int a[10]) { printf(\"%zu\", sizeof(a)); }\nint main(){ int x[10]; f(x); }",
  "options": [
   "40",
   "10",
   "8",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "An array parameter decays to int*, so sizeof(a) is the pointer size, 8 on 64-bit."
 },
 {
  "id": 79,
  "category": "c-arrays",
  "q": "Output?\nint a[5] = {1, 2};\nprintf(\"%d\", a[1] + a[4]);",
  "options": [
   "2",
   "Garbage value",
   "3",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "Elements without an initializer are zero-initialized, so a[4] is 0 and the sum is 2."
 },
 {
  "id": 80,
  "category": "c-arrays",
  "q": "Output?\nint a[] = {10, 20, 30, 40};\nint *p = a + 1;\nprintf(\"%d\", *(p + 2));",
  "options": [
   "30",
   "20",
   "40",
   "Undefined behavior"
  ],
  "correctIndex": 2,
  "explanation": "p points to a[1], so p+2 points to a[3], which is 40."
 },
 {
  "id": 81,
  "category": "c-arrays",
  "q": "What is printed?\nint a[5];\nprintf(\"%td\", &a[4] - &a[1]);",
  "options": [
   "3",
   "12",
   "4",
   "Undefined behavior"
  ],
  "correctIndex": 0,
  "explanation": "Subtracting pointers into the same array gives the element count between them, not bytes: 4-1 = 3."
 },
 {
  "id": 82,
  "category": "c-arrays",
  "q": "Output?\nint a[] = {5, 6, 7};\nprintf(\"%d\", 2[a]);",
  "options": [
   "Compile error",
   "6",
   "Undefined behavior",
   "7"
  ],
  "correctIndex": 3,
  "explanation": "a[i] is defined as *(a+i), which is commutative, so 2[a] is the same as a[2], i.e. 7."
 },
 {
  "id": 83,
  "category": "c-arrays",
  "q": "What happens?\nchar buf[4];\nstrcpy(buf, \"hello\");",
  "options": [
   "Copies \"hell\" safely",
   "Compile-time error",
   "Undefined behavior from buffer overflow",
   "Returns NULL and copies nothing"
  ],
  "correctIndex": 2,
  "explanation": "strcpy copies 6 bytes including '\\0' into a 4-byte buffer, which is undefined behavior."
 },
 {
  "id": 84,
  "category": "c-arrays",
  "q": "What does strcmp(\"apple\", \"apricot\") return?",
  "options": [
   "0",
   "A positive value",
   "A negative value",
   "1 exactly"
  ],
  "correctIndex": 2,
  "explanation": "The strings first differ at index 2, where 'p' < 'r', so the result is negative. The standard guarantees only the sign."
 },
 {
  "id": 85,
  "category": "c-arrays",
  "q": "Which statement is undefined behavior?",
  "options": [
   "char s[] = \"abc\"; s[0] = 'x';",
   "char *p = \"abc\"; p[0] = 'x';",
   "char s[] = \"abc\"; char *p = s; p[1] = 'y';",
   "char s[4] = \"abc\"; s[3] = 'z';"
  ],
  "correctIndex": 1,
  "explanation": "Modifying a string literal through a char* is undefined behavior. The other statements modify writable arrays."
 },
 {
  "id": 86,
  "category": "c-arrays",
  "q": "Output?\nchar s[] = \"hello\";\ns[2] = '\\0';\nprintf(\"%s %zu\", s, strlen(s));",
  "options": [
   "hello 5",
   "he 2",
   "hel 3",
   "he 5"
  ],
  "correctIndex": 1,
  "explanation": "Placing '\\0' at index 2 ends the string, so it prints \"he\" and strlen is 2."
 },
 {
  "id": 87,
  "category": "c-arrays",
  "q": "Assuming a 4-byte int, what is printed?\nint a[3][4];\nprintf(\"%zu\", sizeof(a[1]));",
  "options": [
   "4",
   "12",
   "16",
   "48"
  ],
  "correctIndex": 2,
  "explanation": "a[1] is a row of 4 ints, so its size is 4*4 = 16 bytes."
 },
 {
  "id": 88,
  "category": "c-arrays",
  "q": "Output?\nint a[2][3] = {{1,2,3},{4,5,6}};\nprintf(\"%d\", *(*(a+1)+2));",
  "options": [
   "6",
   "5",
   "3",
   "4"
  ],
  "correctIndex": 0,
  "explanation": "*(a+1) is row 1, adding 2 selects its third element, and dereferencing gives a[1][2] = 6."
 },
 {
  "id": 89,
  "category": "c-arrays",
  "q": "Output?\nint a[] = {1, 2, 3};\nint *p = a;\n*p++ = 9;\nprintf(\"%d %d\", a[0], *p);",
  "options": [
   "9 2",
   "1 2",
   "9 9",
   "1 9"
  ],
  "correctIndex": 0,
  "explanation": "The post-increment moves p after the assignment, so a[0] becomes 9 and p now points to a[1], which is 2."
 },
 {
  "id": 90,
  "category": "c-arrays",
  "q": "For char s[10] = \"hi\"; what are sizeof(s) and strlen(s)?",
  "options": [
   "2 and 2",
   "10 and 10",
   "3 and 2",
   "10 and 2"
  ],
  "correctIndex": 3,
  "explanation": "sizeof is the declared array size, 10. strlen counts characters before '\\0', which is 2."
 },
 {
  "id": 91,
  "category": "c-arrays",
  "q": "Why is this risky?\nchar s[5] = \"hello\";\nprintf(\"%s\", s);",
  "options": [
   "It is a compile error in C11",
   "s has no room for '\\0', so printing may read past the array",
   "It prints \"hell\"",
   "It allocates 6 bytes automatically"
  ],
  "correctIndex": 1,
  "explanation": "C allows exact-fit initialization with no terminator, so %s reads beyond the array, which is undefined behavior."
 },
 {
  "id": 92,
  "category": "c-arrays",
  "q": "Array has n-1 distinct numbers from 1..n with one missing. Best way to find it?",
  "options": [
   "Sort and scan, O(n log n) time",
   "Sum formula n(n+1)/2 minus array sum, O(n) time, O(1) space",
   "Nested loop, O(n^2) time",
   "Hash set, O(1) extra space"
  ],
  "correctIndex": 1,
  "explanation": "The expected sum minus the actual sum gives the missing number in one pass with constant space. XOR works too and avoids overflow."
 },
 {
  "id": 93,
  "category": "c-arrays",
  "q": "Output?\nprintf(\"%c\", \"hello\"[1]);",
  "options": [
   "h",
   "e",
   "Compile error",
   "l"
  ],
  "correctIndex": 1,
  "explanation": "A string literal is an array of char, so indexing it with [1] yields the second character, 'e'."
 },
 {
  "id": 94,
  "category": "c-arrays",
  "q": "Which statement causes a compile error?\nint a[5]; int *p = a;",
  "options": [
   "p = p + 1;",
   "*(a + 1) = 5;",
   "a = a + 1;",
   "a[1] = 5;"
  ],
  "correctIndex": 2,
  "explanation": "An array name is not a modifiable lvalue, so it cannot be assigned to. A pointer variable can be."
 },
 {
  "id": 95,
  "category": "c-arrays",
  "q": "What is the problem?\nchar d[6];\nstrncpy(d, \"abcdefgh\", 3);\nprintf(\"%s\", d);",
  "options": [
   "strncpy always adds '\\0', so it is fine",
   "Compile error due to size mismatch",
   "strncpy copies 6 chars",
   "d is not null-terminated, so printing is undefined behavior"
  ],
  "correctIndex": 3,
  "explanation": "strncpy does not append '\\0' when the source is longer than n, and d is uninitialized, so %s reads indeterminate data."
 },
 {
  "id": 96,
  "category": "c-arrays",
  "q": "Output?\nchar s[] = \"ab\";\nchar t[] = \"ab\";\nprintf(\"%d\", s == t);",
  "options": [
   "1",
   "0",
   "Compile error",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "s and t are separate arrays, so == compares their different base addresses, not their contents, and gives 0."
 },
 {
  "id": 97,
  "category": "c-arrays",
  "q": "Assuming a 4-byte int and 8-byte pointers, what is printed?\nint a[2][3];\nint (*p)[3] = a;\nprintf(\"%zu\", sizeof(*p));",
  "options": [
   "3",
   "8",
   "4",
   "12"
  ],
  "correctIndex": 3,
  "explanation": "p is a pointer to an array of 3 ints, so *p is that array and its size is 3*4 = 12 bytes."
 },
 {
  "id": 98,
  "category": "c-arrays",
  "q": "Output?\nchar s[] = \"abc\";\nprintf(\"%d\", strlen(s) - strlen(\"abcd\") > 0);",
  "options": [
   "1",
   "0",
   "-1",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "strlen returns unsigned size_t, so 3 - 4 wraps to a huge positive value and the comparison is true (1)."
 },
 {
  "id": 99,
  "category": "c-arrays",
  "q": "Output?\nchar s[] = \"abc\";\nchar *p = s;\np++;\nprintf(\"%s %c\", p, *s);",
  "options": [
   "abc a",
   "bc b",
   "bc a",
   "c a"
  ],
  "correctIndex": 2,
  "explanation": "p points to s[1], so %s prints \"bc\", while *s is still the first character 'a'."
 },
 {
  "id": 100,
  "category": "c-arrays",
  "q": "Array of n+1 integers, each in 1..n, has one repeated value. Find it in O(n) time and O(1) space without modifying the array.",
  "options": [
   "Sort the array and compare neighbours",
   "Treat values as next-pointers and use Floyd's cycle detection",
   "Store counts in a hash set",
   "Use two nested loops"
  ],
  "correctIndex": 1,
  "explanation": "Treating a[i] as a next index forms a cycle whose entry point is the duplicate. Floyd's algorithm finds it in O(n) time with O(1) space and no modification."
 },
 {
  "id": 101,
  "category": "structs-files",
  "q": "On a typical platform with 4-byte int and 4-byte alignment for int, what is sizeof(struct {char c; int i;})?",
  "options": [
   "5",
   "8",
   "6",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "3 padding bytes follow c so that i is 4-byte aligned, giving 1+3+4 = 8."
 },
 {
  "id": 102,
  "category": "structs-files",
  "q": "On a little-endian machine with 4-byte int: union U {int i; char c;} u; u.i = 65; printf(\"%c\", u.c); prints what?",
  "options": [
   "Garbage value",
   "Nothing",
   "A",
   "6"
  ],
  "correctIndex": 2,
  "explanation": "Little-endian stores the low byte (65 = 'A') first, and c overlays that first byte."
 },
 {
  "id": 103,
  "category": "structs-files",
  "q": "Which fopen mode truncates an existing file to zero length, or creates it if missing, and opens it for writing?",
  "options": [
   "\"r+\"",
   "\"a\"",
   "\"w\"",
   "\"rb\""
  ],
  "correctIndex": 2,
  "explanation": "\"w\" discards any existing contents; \"a\" appends and \"r+\" requires the file to exist and keeps its contents."
 },
 {
  "id": 104,
  "category": "structs-files",
  "q": "Which function was removed from the C11 standard because it cannot limit input and causes buffer overflows?",
  "options": [
   "fgets",
   "gets",
   "scanf",
   "fread"
  ],
  "correctIndex": 1,
  "explanation": "gets() was deprecated in C99 and removed in C11; fgets takes a size limit."
 },
 {
  "id": 105,
  "category": "structs-files",
  "q": "What does fread(buf, sizeof(int), 10, fp) return?",
  "options": [
   "Number of bytes read",
   "Number of items successfully read",
   "Always 10 or 0",
   "The file position"
  ],
  "correctIndex": 1,
  "explanation": "fread returns the count of complete items read, which may be less than 10 on EOF or error."
 },
 {
  "id": 106,
  "category": "structs-files",
  "q": "struct S {int a[2];}; struct S s1={{1,2}}, s2=s1; s2.a[0]=9; printf(\"%d\", s1.a[0]); prints?",
  "options": [
   "9",
   "1",
   "2",
   "Undefined"
  ],
  "correctIndex": 1,
  "explanation": "Struct assignment copies array members element by element, so s1 is unaffected."
 },
 {
  "id": 107,
  "category": "structs-files",
  "q": "Typical 64-bit platform: what is sizeof(union {int a; double d; char s[10];})?",
  "options": [
   "10",
   "8",
   "16",
   "22"
  ],
  "correctIndex": 2,
  "explanation": "The largest member is 10 bytes, rounded up to a multiple of the 8-byte alignment of double, giving 16."
 },
 {
  "id": 108,
  "category": "structs-files",
  "q": "Why is while(!feof(fp)) { fgets(buf,N,fp); process(buf); } considered a bug?",
  "options": [
   "feof is not in C11",
   "feof needs fclose first",
   "EOF flag is set only after a failed read, so the last line is processed twice",
   "fgets cannot be used in loops"
  ],
  "correctIndex": 2,
  "explanation": "feof becomes true only after a read hits EOF, so one extra iteration runs with stale buffer data."
 },
 {
  "id": 109,
  "category": "structs-files",
  "q": "A file is opened in binary mode. Which sequence portably gives its size in bytes?",
  "options": [
   "fseek(fp,0,SEEK_END); ftell(fp);",
   "fseek(fp,0,SEEK_SET); ftell(fp);",
   "rewind(fp); feof(fp);",
   "fflush(fp); ftell(fp);"
  ],
  "correctIndex": 0,
  "explanation": "Seeking to the end and calling ftell returns the offset of the end, which is the size in bytes for a binary stream."
 },
 {
  "id": 110,
  "category": "structs-files",
  "q": "struct B {unsigned int a:3;} s; s.a = 9; printf(\"%u\", s.a); prints?",
  "options": [
   "9",
   "0",
   "1",
   "3"
  ],
  "correctIndex": 2,
  "explanation": "9 is binary 1001, and a 3-bit field keeps only the low 3 bits (001), which is 1."
 },
 {
  "id": 111,
  "category": "structs-files",
  "q": "If p is a pointer to a struct with member x, which expression is equivalent to p->x?",
  "options": [
   "*p.x",
   "(*p).x",
   "&p.x",
   "p.x"
  ],
  "correctIndex": 1,
  "explanation": "-> dereferences then selects; *p.x is wrong because . binds tighter than *."
 },
 {
  "id": 112,
  "category": "structs-files",
  "q": "C11: struct T {int n; int arr[];}; What is typically sizeof(struct T) with 4-byte int?",
  "options": [
   "4",
   "8",
   "Compile error",
   "Depends on n"
  ],
  "correctIndex": 0,
  "explanation": "A flexible array member contributes no size; you allocate extra memory with malloc for the elements."
 },
 {
  "id": 113,
  "category": "structs-files",
  "q": "Which reordering reduces padding? struct A {char a; double b; char c;}; (typical 64-bit, sizeof = 24)",
  "options": [
   "{char a; char c; double b;} gives 16",
   "{double b; char a; char c;} gives 12",
   "No reordering changes size",
   "{char c; double b; char a;} gives 16"
  ],
  "correctIndex": 0,
  "explanation": "Placing the two chars together uses 2 bytes, pads 6, then the 8-byte double, so the total is 16."
 },
 {
  "id": 114,
  "category": "structs-files",
  "q": "A struct containing a char* name is written using fwrite(&s, sizeof s, 1, fp). What is saved for name?",
  "options": [
   "The pointed-to string",
   "The pointer value only, which is useless after restart",
   "Nothing; fwrite skips pointers",
   "A null-terminated copy"
  ],
  "correctIndex": 1,
  "explanation": "fwrite copies raw bytes of the struct, so the address is stored, not the string data."
 },
 {
  "id": 115,
  "category": "structs-files",
  "q": "struct P {int x; int y;}; struct P p = {.y = 5}; printf(\"%d %d\", p.x, p.y); prints?",
  "options": [
   "Garbage 5",
   "0 5",
   "5 0",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "Members not named in a designated initializer are zero-initialized."
 },
 {
  "id": 116,
  "category": "structs-files",
  "q": "union {float f; unsigned u;} v; v.f = 1.0f; With 32-bit IEEE-754 float and 32-bit unsigned, printf(\"%x\", v.u) prints?",
  "options": [
   "1",
   "3f800000",
   "41200000",
   "0"
  ],
  "correctIndex": 1,
  "explanation": "IEEE-754 single precision 1.0 is 0x3F800000, and the union reinterprets those bytes."
 },
 {
  "id": 117,
  "category": "structs-files",
  "q": "What does rewind(fp) do compared with fseek(fp, 0, SEEK_SET)?",
  "options": [
   "Same, but also clears the error and EOF indicators",
   "Same, but returns the new position",
   "Truncates the file",
   "Flushes and closes the file"
  ],
  "correctIndex": 0,
  "explanation": "rewind is like fseek to the start but also clears the stream's error/EOF flags and returns no value."
 },
 {
  "id": 118,
  "category": "structs-files",
  "q": "What is the difference between puts(s) and fputs(s, stdout)?",
  "options": [
   "puts is faster only",
   "fputs adds a newline",
   "puts appends a newline; fputs does not",
   "No difference"
  ],
  "correctIndex": 2,
  "explanation": "puts writes the string plus '\\n', whereas fputs writes the string as-is."
 },
 {
  "id": 119,
  "category": "structs-files",
  "q": "Which declaration is invalid in C? ",
  "options": [
   "struct N {int d; struct N *next;};",
   "struct N {int d; struct N next;};",
   "struct N {int d; struct N *a[2];};",
   "struct N {int d; void *p;};"
  ],
  "correctIndex": 1,
  "explanation": "A struct cannot contain itself as a member because its size would be infinite; use a pointer."
 },
 {
  "id": 120,
  "category": "structs-files",
  "q": "fopen(\"data.txt\", \"r\") is called on a file that does not exist. What is the result?",
  "options": [
   "Creates an empty file",
   "Returns NULL",
   "Returns stdin",
   "Undefined behavior at once"
  ],
  "correctIndex": 1,
  "explanation": "fopen returns NULL on failure, and \"r\" never creates a file, so the result must be checked."
 },
 {
  "id": 121,
  "category": "preproc",
  "q": "Which gcc flag stops after the preprocessing stage and prints the expanded source to stdout?",
  "options": [
   "-S",
   "-E",
   "-c",
   "-O0"
  ],
  "correctIndex": 1,
  "explanation": "gcc -E runs only the preprocessor (include expansion, macros, conditionals); -S stops at assembly and -c at the object file."
 },
 {
  "id": 122,
  "category": "preproc",
  "q": "Output?\n#define SQ(x) x*x\nprintf(\"%d\", SQ(2+3));",
  "options": [
   "25",
   "11",
   "13",
   "10"
  ],
  "correctIndex": 1,
  "explanation": "The macro expands textually to 2+3*2+3 = 2+6+3 = 11, because there are no parentheses around x."
 },
 {
  "id": 123,
  "category": "preproc",
  "q": "Output?\n#define MAX(a,b) ((a)>(b)?(a):(b))\nint i=5,j=3;\nint m=MAX(i++,j);\nprintf(\"%d %d\",m,i);",
  "options": [
   "6 7",
   "5 6",
   "5 7",
   "6 6"
  ],
  "correctIndex": 0,
  "explanation": "i++ is evaluated twice: the condition yields 5 (i=6), then the true branch yields 6 (i=7), so m=6 and i=7."
 },
 {
  "id": 124,
  "category": "preproc",
  "q": "Output?\n#define STR(x) #x\nprintf(\"%s\", STR(hello));",
  "options": [
   "x",
   "Compile error",
   "hello",
   "0"
  ],
  "correctIndex": 2,
  "explanation": "The # operator turns the macro argument into the string literal \"hello\"."
 },
 {
  "id": 125,
  "category": "preproc",
  "q": "Output?\n#define CAT(a,b) a##b\nint xy=10;\nprintf(\"%d\", CAT(x,y));",
  "options": [
   "xy",
   "Compile error",
   "x10",
   "10"
  ],
  "correctIndex": 3,
  "explanation": "The ## operator pastes the tokens x and y into the identifier xy, which is the variable with value 10."
 },
 {
  "id": 126,
  "category": "preproc",
  "q": "In C11, what is the value of the predefined macro __STDC_VERSION__?",
  "options": [
   "201112L",
   "199901L",
   "201710L",
   "199409L"
  ],
  "correctIndex": 0,
  "explanation": "C11 defines __STDC_VERSION__ as 201112L; C99 is 199901L and C17 is 201710L."
 },
 {
  "id": 127,
  "category": "preproc",
  "q": "What is the main purpose of include guards (#ifndef X / #define X / #endif) in a header file?",
  "options": [
   "Speed up the linker",
   "Hide the header from other programs",
   "Prevent multiple inclusion in one translation unit",
   "Make functions static"
  ],
  "correctIndex": 2,
  "explanation": "Guards stop the header body from being processed twice in one translation unit, avoiding redefinition errors."
 },
 {
  "id": 128,
  "category": "preproc",
  "q": "What happens?\n#define A 5\n#undef A\nint main(){ printf(\"%d\", A); }",
  "options": [
   "Prints 5",
   "Compile error: A undeclared",
   "Prints 0",
   "Linker error"
  ],
  "correctIndex": 1,
  "explanation": "After #undef the name A is no longer a macro, so it is treated as an undeclared identifier."
 },
 {
  "id": 129,
  "category": "preproc",
  "q": "How does #include \"file.h\" typically differ from #include <file.h>?",
  "options": [
   "Quotes include only .c files",
   "Angle brackets include only user files",
   "They are identical",
   "Quotes search the local directory first, then standard paths"
  ],
  "correctIndex": 3,
  "explanation": "The search order is implementation-defined, but quoted includes usually look in the including file's directory first and then fall back to the system paths."
 },
 {
  "id": 130,
  "category": "preproc",
  "q": "A program calls int foo(void); which is declared but never defined anywhere. At which stage is the error reported?",
  "options": [
   "Preprocessing",
   "Compilation (syntax check)",
   "Linking",
   "Runtime"
  ],
  "correctIndex": 2,
  "explanation": "The declaration satisfies the compiler, but the linker cannot resolve the symbol and reports an undefined reference."
 },
 {
  "id": 131,
  "category": "preproc",
  "q": "Which of these directives is INVALID in C?",
  "options": [
   "#if defined(X) && X > 2",
   "#if sizeof(int) == 4",
   "#if 1+2 == 3",
   "#if __STDC_VERSION__ >= 201112L"
  ],
  "correctIndex": 1,
  "explanation": "The preprocessor runs before type analysis, so sizeof cannot be evaluated in #if expressions."
 },
 {
  "id": 132,
  "category": "preproc",
  "q": "Why are multi-statement macros commonly written as do { ... } while(0)?",
  "options": [
   "To behave as a single statement, safe in if-else with a trailing semicolon",
   "To make the macro run faster",
   "To allow recursion in macros",
   "To avoid using parentheses"
  ],
  "correctIndex": 0,
  "explanation": "The do-while(0) wrapper makes the macro a single statement, so if (c) M(); else ... parses correctly."
 },
 {
  "id": 133,
  "category": "preproc",
  "q": "Under strict C11, what is the problem with:\n#define LOG(f, ...) printf(f, __VA_ARGS__)\nLOG(\"hi\");",
  "options": [
   "Works fine and prints hi",
   "Prints garbage",
   "Infinite expansion",
   "No variadic argument is given, and the expansion leaves a trailing comma"
  ],
  "correctIndex": 3,
  "explanation": "C11 requires at least one argument for ..., and the expansion printf(\"hi\", ) is a syntax error; GNU ##__VA_ARGS__ is a non-standard workaround."
 },
 {
  "id": 134,
  "category": "preproc",
  "q": "Output?\n#define DOUBLE(x) (x)+(x)\nprintf(\"%d\", 3*DOUBLE(2));",
  "options": [
   "12",
   "6",
   "8",
   "10"
  ],
  "correctIndex": 2,
  "explanation": "It expands to 3*(2)+(2) = 6+2 = 8, so the outer parentheses are missing."
 },
 {
  "id": 135,
  "category": "preproc",
  "q": "Output?\n#define DEBUG 0\n#ifdef DEBUG\nputs(\"on\");\n#else\nputs(\"off\");\n#endif",
  "options": [
   "on",
   "off",
   "Nothing is printed",
   "Compile error"
  ],
  "correctIndex": 0,
  "explanation": "#ifdef only checks whether the macro is defined, not its value, so DEBUG defined as 0 still selects the \"on\" branch."
 },
 {
  "id": 136,
  "category": "c-funcs",
  "q": "What is the output?\n int f(int n){ if(n==0) return 0; return n + f(n-1); }\n printf(\"%d\", f(4));",
  "options": [
   "4",
   "10",
   "24",
   "Infinite recursion"
  ],
  "correctIndex": 1,
  "explanation": "f(4)=4+3+2+1+0=10."
 },
 {
  "id": 137,
  "category": "c-funcs",
  "q": "What is printed?\n void f(){ static int c=0; c++; printf(\"%d \", c); }\n int main(){ f(); f(); f(); }",
  "options": [
   "1 1 1",
   "0 1 2",
   "1 2 3",
   "Garbage values"
  ],
  "correctIndex": 2,
  "explanation": "A static local is initialized once and keeps its value across calls, so it prints 1 2 3."
 },
 {
  "id": 138,
  "category": "c-funcs",
  "q": "What is the output?\n void swap(int a,int b){ int t=a; a=b; b=t; }\n int main(){ int x=1,y=2; swap(x,y); printf(\"%d %d\",x,y); }",
  "options": [
   "2 1",
   "1 2",
   "1 1",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "C passes arguments by value, so swap changes only its own copies."
 },
 {
  "id": 139,
  "category": "c-funcs",
  "q": "In C, what is guaranteed about the order in which function arguments are evaluated in f(a(), b())?",
  "options": [
   "Left to right",
   "Right to left",
   "Unspecified order",
   "Always evaluated in parallel"
  ],
  "correctIndex": 2,
  "explanation": "The C standard leaves the evaluation order of function arguments unspecified."
 },
 {
  "id": 140,
  "category": "c-funcs",
  "q": "What is the output?\n void f(int n){ if(!n) return; printf(\"%d\",n); f(n-1); printf(\"%d\",n); }\n f(3);",
  "options": [
   "321123",
   "123321",
   "321",
   "333111"
  ],
  "correctIndex": 0,
  "explanation": "It prints 3,2,1 on the way down, then 1,2,3 as the calls return, giving 321123."
 },
 {
  "id": 141,
  "category": "c-funcs",
  "q": "What typically happens when a recursive function has no reachable base case?",
  "options": [
   "Compiler rejects it",
   "Returns 0 automatically",
   "Stack overflow at runtime (undefined behavior)",
   "The heap is used so it runs forever safely"
  ],
  "correctIndex": 2,
  "explanation": "Each call adds a stack frame, so the stack is eventually exhausted, usually causing a segmentation fault."
 },
 {
  "id": 142,
  "category": "c-funcs",
  "q": "What is the time complexity of naive recursive Fibonacci: fib(n)=fib(n-1)+fib(n-2)?",
  "options": [
   "O(n)",
   "O(n log n)",
   "O(n^2)",
   "Exponential, O(2^n)"
  ],
  "correctIndex": 3,
  "explanation": "The recursion tree branches into two calls and recomputes subproblems, so the cost grows exponentially (tightly about φ^n)."
 },
 {
  "id": 143,
  "category": "c-funcs",
  "q": "Which of these is a tail-recursive return statement in a function f?",
  "options": [
   "return n * f(n-1);",
   "return f(n-1) + 1;",
   "return f(n-1) + f(n-2);",
   "return f(n-1, acc*n);"
  ],
  "correctIndex": 3,
  "explanation": "Only in the last option is the recursive call the final operation, with no work left after it returns."
 },
 {
  "id": 144,
  "category": "c-funcs",
  "q": "What does the declaration int (*fp)(int, int); declare?",
  "options": [
   "A function returning int* that takes two ints",
   "A pointer to a function taking two ints and returning int",
   "An array of two int pointers",
   "A pointer to an int array of size 2"
  ],
  "correctIndex": 1,
  "explanation": "The parentheses around *fp make fp a pointer to a function (int,int) returning int."
 },
 {
  "id": 145,
  "category": "c-funcs",
  "q": "On a typical 64-bit system, what is printed?\n void f(int a[10]){ printf(\"%zu\", sizeof(a)); }\n int main(){ int arr[10]; f(arr); }",
  "options": [
   "40",
   "10",
   "8",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "The array parameter decays to int*, so sizeof(a) is the pointer size (8 bytes)."
 },
 {
  "id": 146,
  "category": "c-funcs",
  "q": "What does this function return for g(48,18)?\n int g(int a,int b){ return b ? g(b,a%b) : a; }",
  "options": [
   "3",
   "6",
   "12",
   "18"
  ],
  "correctIndex": 1,
  "explanation": "This is Euclid's algorithm: (48,18)→(18,12)→(12,6)→(6,0), which returns 6."
 },
 {
  "id": 147,
  "category": "c-funcs",
  "q": "What is the output?\n #define SQ(x) x*x\n printf(\"%d\", SQ(2+1));",
  "options": [
   "9",
   "5",
   "6",
   "Compile error"
  ],
  "correctIndex": 1,
  "explanation": "The macro expands to 2+1*2+1, which is 5, because there are no parentheses around x."
 },
 {
  "id": 148,
  "category": "c-funcs",
  "q": "Which header must be included to use va_list, va_start and va_arg for variadic functions?",
  "options": [
   "<stdlib.h>",
   "<stdio.h>",
   "<stddef.h>",
   "<stdarg.h>"
  ],
  "correctIndex": 3,
  "explanation": "<stdarg.h> declares the macros for accessing variable argument lists."
 },
 {
  "id": 149,
  "category": "c-funcs",
  "q": "What does f(95) return?\n int f(int n){ if(n>100) return n-10; return f(f(n+11)); }",
  "options": [
   "91",
   "95",
   "101",
   "Infinite recursion"
  ],
  "correctIndex": 0,
  "explanation": "This is McCarthy's 91 function, which returns 91 for every n ≤ 100."
 },
 {
  "id": 150,
  "category": "c-funcs",
  "q": "What is wrong with this function?\n int* f(){ int x=5; return &x; }",
  "options": [
   "Nothing, it is valid and safe",
   "It returns a dangling pointer to a local variable (UB when dereferenced)",
   "It fails to compile because of the pointer return type",
   "x is automatically promoted to static"
  ],
  "correctIndex": 1,
  "explanation": "x's lifetime ends when f returns, so the returned address is dangling and using it is undefined behavior."
 },
 {
  "id": 151,
  "category": "systems",
  "q": "How many times is X printed?\nint main(){ fork(); fork(); printf(\"X\\n\"); return 0; }",
  "options": [
   "2",
   "3",
   "4",
   "8"
  ],
  "correctIndex": 2,
  "explanation": "Two fork() calls produce 2^2 = 4 processes, and each one prints X."
 },
 {
  "id": 152,
  "category": "systems",
  "q": "A child process has terminated but its parent has not yet called wait(). What state is the child in?",
  "options": [
   "Orphan",
   "Zombie",
   "Daemon",
   "Blocked"
  ],
  "correctIndex": 1,
  "explanation": "A terminated process whose exit status has not been collected by the parent stays in the process table as a zombie."
 },
 {
  "id": 153,
  "category": "systems",
  "q": "After a successful call to int fd[2]; pipe(fd); which descriptor is the read end of the pipe?",
  "options": [
   "fd[1]",
   "Both fd[0] and fd[1]",
   "fd[0]",
   "Neither; pipes are read via stdin only"
  ],
  "correctIndex": 2,
  "explanation": "By POSIX convention fd[0] is the read end and fd[1] is the write end."
 },
 {
  "id": 154,
  "category": "systems",
  "q": "Which of these is NOT one of the four necessary conditions for deadlock?",
  "options": [
   "Mutual exclusion",
   "Hold and wait",
   "Circular wait",
   "Preemption of resources"
  ],
  "correctIndex": 3,
  "explanation": "Deadlock requires NO preemption; being able to preempt resources breaks the condition."
 },
 {
  "id": 155,
  "category": "systems",
  "q": "What does this code do?\nchar *p = malloc(10);\nfree(p);\nfree(p);",
  "options": [
   "Frees memory twice safely",
   "Returns an error code from free",
   "Undefined behavior (double free)",
   "Compile-time error"
  ],
  "correctIndex": 2,
  "explanation": "Calling free() twice on the same pointer is undefined behavior and often corrupts the heap or aborts."
 },
 {
  "id": 156,
  "category": "systems",
  "q": "On a typical 64-bit system with default alignment, what is sizeof(struct S) for struct S { char c; int i; char d; };?",
  "options": [
   "6",
   "8",
   "12",
   "16"
  ],
  "correctIndex": 2,
  "explanation": "c is followed by 3 padding bytes, i takes 4, d takes 1 plus 3 trailing padding bytes so the size is a multiple of 4: 12 bytes."
 },
 {
  "id": 157,
  "category": "systems",
  "q": "A page fault occurs when a process:",
  "options": [
   "Writes to a file on disk",
   "Accesses a page not currently mapped in physical memory",
   "Divides by zero",
   "Calls a system call"
  ],
  "correctIndex": 1,
  "explanation": "A page fault is raised when the referenced page has no valid mapping in physical memory, for example because it is swapped out or not yet loaded."
 },
 {
  "id": 158,
  "category": "systems",
  "q": "In Round Robin scheduling, what happens as the time quantum becomes very large?",
  "options": [
   "It behaves like FCFS",
   "It behaves like SJF",
   "Context switches increase",
   "It becomes priority scheduling"
  ],
  "correctIndex": 0,
  "explanation": "If the quantum exceeds every burst time, each process runs to completion in arrival order, which is FCFS."
 },
 {
  "id": 159,
  "category": "systems",
  "q": "What is a key difference between a mutex and a binary semaphore?",
  "options": [
   "A mutex can count above 1",
   "A mutex has an owner; only the locking thread should unlock it",
   "A semaphore cannot block",
   "A mutex works only across processes"
  ],
  "correctIndex": 1,
  "explanation": "A mutex has ownership semantics, while a binary semaphore can be signaled by any thread."
 },
 {
  "id": 160,
  "category": "systems",
  "q": "What is printed?\nint x=5; pid_t p=fork();\nif(p==0){ x++; return 0; }\nwait(NULL); printf(\"%d\", x);",
  "options": [
   "5",
   "6",
   "11",
   "Undefined"
  ],
  "correctIndex": 0,
  "explanation": "The child modifies its own copy of x (separate address space, copy-on-write), so the parent still sees 5."
 },
 {
  "id": 161,
  "category": "systems",
  "q": "What does execl() return when it succeeds?",
  "options": [
   "0",
   "The new process PID",
   "Never returns",
   "1"
  ],
  "correctIndex": 2,
  "explanation": "On success the process image is replaced, so execl() does not return; it returns -1 only on failure."
 },
 {
  "id": 162,
  "category": "systems",
  "q": "Thrashing in an operating system is characterized by:",
  "options": [
   "High CPU utilization with few page faults",
   "Excessive paging that reduces CPU utilization",
   "Too many processes in the ready queue",
   "Disk failure"
  ],
  "correctIndex": 1,
  "explanation": "In thrashing the system spends most of its time swapping pages in and out, so useful CPU work drops."
 },
 {
  "id": 163,
  "category": "systems",
  "q": "Belady's anomaly, where more frames cause more page faults, can occur with which replacement algorithm?",
  "options": [
   "LRU",
   "Optimal",
   "FIFO",
   "Both LRU and Optimal"
  ],
  "correctIndex": 2,
  "explanation": "FIFO is not a stack algorithm, so it can show Belady's anomaly, while LRU and Optimal cannot."
 },
 {
  "id": 164,
  "category": "systems",
  "q": "Two threads each run `counter++` 1,000,000 times on a shared int with no synchronization. The final value is:",
  "options": [
   "Always exactly 2000000",
   "Always exactly 1000000",
   "Unpredictable, often less than 2000000",
   "Always 0"
  ],
  "correctIndex": 2,
  "explanation": "counter++ is a non-atomic read-modify-write, so updates can be lost in a data race."
 },
 {
  "id": 165,
  "category": "systems",
  "q": "On a file descriptor, read(fd, buf, n) returns 0. What does that mean?",
  "options": [
   "An error occurred",
   "End of file was reached",
   "The call was interrupted by a signal",
   "The descriptor is non-blocking and empty"
  ],
  "correctIndex": 1,
  "explanation": "read() returns 0 at EOF, -1 on error, and -1 with errno EAGAIN for an empty non-blocking descriptor."
 },
 {
  "id": 166,
  "category": "sql",
  "q": "Which SQL clause is used to filter groups after aggregation has been applied?",
  "options": [
   "WHERE",
   "HAVING",
   "GROUP BY",
   "ORDER BY"
  ],
  "correctIndex": 1,
  "explanation": "HAVING filters groups using aggregate conditions; WHERE filters rows before grouping."
 },
 {
  "id": 167,
  "category": "sql",
  "q": "Table t(x) holds the values 1, 2, NULL, 3. What does SELECT COUNT(*), COUNT(x) FROM t; return?",
  "options": [
   "3, 3",
   "4, 4",
   "4, 3",
   "3, 4"
  ],
  "correctIndex": 2,
  "explanation": "COUNT(*) counts all 4 rows; COUNT(x) ignores the NULL, giving 3."
 },
 {
  "id": 168,
  "category": "sql",
  "q": "What does SELECT 10 + NULL; return in standard SQL?",
  "options": [
   "10",
   "0",
   "Error",
   "NULL"
  ],
  "correctIndex": 3,
  "explanation": "Any arithmetic with NULL yields NULL (unknown)."
 },
 {
  "id": 169,
  "category": "sql",
  "q": "Which normal form removes transitive dependencies of non-key attributes on the primary key?",
  "options": [
   "Third Normal Form (3NF)",
   "Second Normal Form (2NF)",
   "First Normal Form (1NF)",
   "Fourth Normal Form (4NF)"
  ],
  "correctIndex": 0,
  "explanation": "3NF requires non-key attributes to depend only on the key, not on other non-key attributes."
 },
 {
  "id": 170,
  "category": "sql",
  "q": "In a C program using the SQLite C API, which function compiles SQL text into a prepared statement object?",
  "options": [
   "sqlite3_open",
   "sqlite3_step",
   "sqlite3_prepare_v2",
   "sqlite3_finalize"
  ],
  "correctIndex": 2,
  "explanation": "sqlite3_prepare_v2 compiles SQL into a sqlite3_stmt; step runs it and finalize frees it."
 },
 {
  "id": 171,
  "category": "sql",
  "q": "In C with SQLite, what does sqlite3_step() return when a result row is ready to be read?",
  "options": [
   "SQLITE_OK",
   "SQLITE_DONE",
   "SQLITE_BUSY",
   "SQLITE_ROW"
  ],
  "correctIndex": 3,
  "explanation": "SQLITE_ROW means a row is available; SQLITE_DONE means the statement finished."
 },
 {
  "id": 172,
  "category": "sql",
  "q": "emp(sal) contains 100, 200, 200, 300. What does SELECT COUNT(DISTINCT sal) FROM emp; return?",
  "options": [
   "3",
   "4",
   "2",
   "1"
  ],
  "correctIndex": 0,
  "explanation": "The distinct values are 100, 200 and 300, so the count is 3."
 },
 {
  "id": 173,
  "category": "sql",
  "q": "emp(sal) has 100, 200, 200, 300. Output of: SELECT MAX(sal) FROM emp WHERE sal < (SELECT MAX(sal) FROM emp);",
  "options": [
   "300",
   "200",
   "100",
   "NULL"
  ],
  "correctIndex": 1,
  "explanation": "The subquery returns 300; the largest salary below 300 is 200."
 },
 {
  "id": 174,
  "category": "sql",
  "q": "In a C application, what is the best defence against SQL injection when building queries from user input?",
  "options": [
   "Build the query with sprintf and strip spaces",
   "Convert input to uppercase",
   "Use parameterized queries with bound values (e.g. sqlite3_bind_text)",
   "Limit the input buffer to 50 chars"
  ],
  "correctIndex": 2,
  "explanation": "Bound parameters keep data separate from SQL code, so input cannot alter the query structure."
 },
 {
  "id": 175,
  "category": "sql",
  "q": "Which ACID property guarantees that committed data survives a system crash?",
  "options": [
   "Durability",
   "Atomicity",
   "Consistency",
   "Isolation"
  ],
  "correctIndex": 0,
  "explanation": "Durability means committed changes are persisted, typically via write-ahead logging."
 },
 {
  "id": 176,
  "category": "sql",
  "q": "A.id = {1,2,3}; B.id = {1,1,2}. What does SELECT COUNT(*) FROM A LEFT JOIN B ON A.id = B.id; return?",
  "options": [
   "3",
   "5",
   "6",
   "4"
  ],
  "correctIndex": 3,
  "explanation": "id 1 matches twice (2 rows), id 2 once, id 3 has no match but is kept: 2+1+1 = 4."
 },
 {
  "id": 177,
  "category": "sql",
  "q": "A.id = {1,2,3}; B.id = {1, NULL}. What does SELECT COUNT(*) FROM A WHERE id NOT IN (SELECT id FROM B); return?",
  "options": [
   "2",
   "0",
   "1",
   "3"
  ],
  "correctIndex": 1,
  "explanation": "NOT IN with a NULL in the list never evaluates to TRUE, so no rows qualify."
 },
 {
  "id": 178,
  "category": "sql",
  "q": "Which statement is a DDL command that removes all rows from a table quickly and does not accept a WHERE clause?",
  "options": [
   "DELETE",
   "DROP ROW",
   "TRUNCATE",
   "REMOVE"
  ],
  "correctIndex": 2,
  "explanation": "TRUNCATE empties the whole table without a WHERE clause; DELETE can filter rows."
 },
 {
  "id": 179,
  "category": "sql",
  "q": "Given a B-tree index on customer.name, which predicate generally cannot use the index efficiently?",
  "options": [
   "WHERE name LIKE '%son'",
   "WHERE name = 'Ravi'",
   "WHERE name LIKE 'Ra%'",
   "WHERE name BETWEEN 'A' AND 'C'"
  ],
  "correctIndex": 0,
  "explanation": "A leading wildcard prevents prefix-based seeking in a B-tree, forcing a scan."
 },
 {
  "id": 180,
  "category": "sql",
  "q": "A has values {1,2,2} and B has {2,3}. What does SELECT COUNT(*) FROM (SELECT v FROM A UNION SELECT v FROM B) AS u; return?",
  "options": [
   "5",
   "4",
   "2",
   "3"
  ],
  "correctIndex": 3,
  "explanation": "UNION removes duplicates, leaving {1,2,3}, so the count is 3."
 },
 {
  "id": 181,
  "category": "sql",
  "q": "Which statement about a PRIMARY KEY is correct in standard SQL?",
  "options": [
   "A table may have several primary keys",
   "It uniquely identifies rows and cannot be NULL",
   "It can contain duplicates if indexed",
   "It must be a single numeric column"
  ],
  "correctIndex": 1,
  "explanation": "A table has one primary key, which enforces uniqueness and NOT NULL (it may be composite)."
 },
 {
  "id": 182,
  "category": "sql",
  "q": "Salaries 100, 200, 200, 300. What does RANK() OVER (ORDER BY sal DESC) give for the row with salary 100?",
  "options": [
   "3",
   "2",
   "4",
   "1"
  ],
  "correctIndex": 2,
  "explanation": "RANK leaves gaps after ties: 300→1, 200→2, 200→2, 100→4."
 },
 {
  "id": 183,
  "category": "sql",
  "q": "In C, what is the correct callback signature for the 3rd argument of sqlite3_exec()?",
  "options": [
   "int cb(void*, int, char**, char**)",
   "void cb(char*, int)",
   "int cb(sqlite3_stmt*)",
   "char* cb(void*, char*)"
  ],
  "correctIndex": 0,
  "explanation": "The callback receives user data, column count, value array and column name array, and returns int."
 },
 {
  "id": 184,
  "category": "sql",
  "q": "Two transactions each hold a lock the other needs and both wait indefinitely. What is this situation called?",
  "options": [
   "Phantom read",
   "Dirty read",
   "Lock escalation",
   "Deadlock"
  ],
  "correctIndex": 3,
  "explanation": "A circular wait on locks is a deadlock; the DBMS resolves it by aborting one transaction."
 },
 {
  "id": 185,
  "category": "sql",
  "q": "What is the logical order of evaluation of SQL query clauses?",
  "options": [
   "SELECT, FROM, WHERE, GROUP BY, HAVING",
   "FROM, WHERE, GROUP BY, HAVING, SELECT, ORDER BY",
   "FROM, GROUP BY, WHERE, SELECT, HAVING",
   "WHERE, FROM, SELECT, GROUP BY, ORDER BY"
  ],
  "correctIndex": 1,
  "explanation": "Logically, rows are sourced, filtered, grouped, group-filtered, projected, then sorted."
 },
 {
  "id": 186,
  "category": "dsa-core",
  "q": "On a typical 64-bit system, what does this print?\n\nvoid f(int a[10]){ printf(\"%zu\", sizeof(a)); }\nint main(){ int x[10]; f(x); }",
  "options": [
   "40",
   "10",
   "4",
   "8"
  ],
  "correctIndex": 3,
  "explanation": "An array parameter decays to a pointer, so sizeof(a) is the pointer size, 8 bytes on 64-bit."
 },
 {
  "id": 187,
  "category": "dsa-core",
  "q": "What is the output?\n\nchar s[] = \"hello\";\nprintf(\"%zu %zu\", sizeof(s), strlen(s));",
  "options": [
   "5 5",
   "6 5",
   "6 6",
   "5 6"
  ],
  "correctIndex": 1,
  "explanation": "sizeof includes the terminating '\\0' (6 bytes), while strlen counts only the 5 characters before it."
 },
 {
  "id": 188,
  "category": "dsa-core",
  "q": "What is the output?\n\nint a[5] = {1, 2, 3};\nprintf(\"%d\", a[3] + a[4]);",
  "options": [
   "0",
   "Garbage value",
   "Compile error",
   "5"
  ],
  "correctIndex": 0,
  "explanation": "With a partial initializer list, the remaining elements are zero-initialized."
 },
 {
  "id": 189,
  "category": "dsa-core",
  "q": "What is the output?\n\nint a[] = {10, 20, 30};\nint *p = a;\nprintf(\"%d\", *(p + 2) - *p);",
  "options": [
   "2",
   "30",
   "20",
   "10"
  ],
  "correctIndex": 2,
  "explanation": "*(p+2) is 30 and *p is 10, so the difference is 20."
 },
 {
  "id": 190,
  "category": "dsa-core",
  "q": "What does this print?\n\nint a[3] = {1, 2, 3};\nint *p = &a[2];\nprintf(\"%td\", p - a);",
  "options": [
   "2",
   "1",
   "8",
   "3"
  ],
  "correctIndex": 0,
  "explanation": "Pointer subtraction gives the number of elements between the two pointers, here 2."
 },
 {
  "id": 191,
  "category": "dsa-core",
  "q": "What is the behavior of this code?\n\nchar *s = \"abc\";\ns[0] = 'x';\nprintf(\"%s\", s);",
  "options": [
   "Prints xbc",
   "Prints abc",
   "Undefined behavior (modifying a string literal)",
   "Compile-time error"
  ],
  "correctIndex": 2,
  "explanation": "String literals may live in read-only memory, so modifying one is undefined behavior; it usually segfaults."
 },
 {
  "id": 192,
  "category": "dsa-core",
  "q": "What is wrong with this code?\n\nchar d[4];\nstrcpy(d, \"abcd\");",
  "options": [
   "Nothing, it is valid",
   "strcpy cannot copy literals",
   "d must be declared const",
   "Buffer overflow: 5 bytes are needed including '\\0'"
  ],
  "correctIndex": 3,
  "explanation": "\"abcd\" needs 5 bytes with the null terminator, so copying into a 4-byte array overflows it."
 },
 {
  "id": 193,
  "category": "dsa-core",
  "q": "What does this print?\n\nprintf(\"%zu\", strlen(\"abc\\0def\"));",
  "options": [
   "7",
   "6",
   "3",
   "8"
  ],
  "correctIndex": 2,
  "explanation": "strlen stops at the first '\\0', which comes after 'abc'."
 },
 {
  "id": 194,
  "category": "dsa-core",
  "q": "What does this print?\n\nprintf(\"%s\", \"hello\" + 2);",
  "options": [
   "llo",
   "ello",
   "hel",
   "he"
  ],
  "correctIndex": 0,
  "explanation": "Adding 2 to the literal's address makes it point at index 2, so the string printed is \"llo\"."
 },
 {
  "id": 195,
  "category": "dsa-core",
  "q": "What is the output?\n\nint a[2][3] = {{1,2,3},{4,5,6}};\nprintf(\"%d\", *(*(a + 1) + 2));",
  "options": [
   "5",
   "6",
   "3",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "*(a+1) is row 1, and adding 2 then dereferencing gives a[1][2], which is 6."
 },
 {
  "id": 196,
  "category": "dsa-core",
  "q": "Why is mid = (low + high) / 2 considered risky in binary search on large int arrays?",
  "options": [
   "low + high can overflow int; use low + (high - low) / 2",
   "Integer division loses precision",
   "It makes the search O(n)",
   "It fails for even-length arrays"
  ],
  "correctIndex": 0,
  "explanation": "The sum of two large ints can overflow, which is undefined behavior; low + (high-low)/2 avoids this."
 },
 {
  "id": 197,
  "category": "dsa-core",
  "q": "What is the maximum subarray sum (Kadane's) for {-2, 1, -3, 4, -1, 2, 1, -5, 4}?",
  "options": [
   "7",
   "6",
   "5",
   "4"
  ],
  "correctIndex": 1,
  "explanation": "The subarray {4, -1, 2, 1} has the largest sum, 6."
 },
 {
  "id": 198,
  "category": "dsa-core",
  "q": "Which technique finds the middle node of a singly linked list in one pass with O(1) extra space?",
  "options": [
   "Store all nodes in an array",
   "Reverse the list first, then count",
   "Slow and fast pointers",
   "Recursion with a global counter"
  ],
  "correctIndex": 2,
  "explanation": "When the fast pointer moves 2 steps per 1 step of the slow one, slow is at the middle when fast reaches the end."
 },
 {
  "id": 199,
  "category": "dsa-core",
  "q": "Time and space complexity of reversing a singly linked list iteratively with three pointers?",
  "options": [
   "O(n) time, O(n) space",
   "O(n log n) time, O(1) space",
   "O(n^2) time, O(1) space",
   "O(n) time, O(1) space"
  ],
  "correctIndex": 3,
  "explanation": "A single pass relinks each node once, using only prev, curr and next pointers."
 },
 {
  "id": 200,
  "category": "dsa-core",
  "q": "Given a sorted array, which approach finds a pair with sum = target in O(n) time and O(1) space?",
  "options": [
   "Two pointers from both ends",
   "Nested loops",
   "Hash set of all elements",
   "Sort then binary search for each element"
  ],
  "correctIndex": 0,
  "explanation": "Moving the left or right pointer based on whether the sum is too small or too large scans the array once."
 },
 {
  "id": 201,
  "category": "dsa-core",
  "q": "An array holds n-1 distinct numbers from 1..n. Best way to find the missing one in O(n) time and O(1) space?",
  "options": [
   "Sort and scan, O(n log n)",
   "Use a hash table of size n",
   "n(n+1)/2 minus array sum, or XOR of all values",
   "Binary search without sorting"
  ],
  "correctIndex": 2,
  "explanation": "The expected sum (or XOR) minus the actual one reveals the missing number with constant extra space; XOR avoids overflow."
 },
 {
  "id": 202,
  "category": "dsa-core",
  "q": "How can an array of n elements be rotated left by k positions in place with O(1) extra space?",
  "options": [
   "Copy to a temporary array of size k only",
   "Reverse first k, reverse the rest, then reverse the whole array",
   "Swap adjacent elements k times only once",
   "Sort the array"
  ],
  "correctIndex": 1,
  "explanation": "Three reversals (first k, remaining n-k, then all n) give the rotation in O(n) time and O(1) space."
 },
 {
  "id": 203,
  "category": "dsa-core",
  "q": "A dynamic array doubles its capacity with realloc when full. What is the amortized cost of appending an element?",
  "options": [
   "O(n)",
   "O(log n)",
   "O(n log n)",
   "O(1)"
  ],
  "correctIndex": 3,
  "explanation": "Occasional O(n) copies are spread across many cheap appends, giving O(1) amortized per push."
 },
 {
  "id": 204,
  "category": "dsa-core",
  "q": "What is the output?\n\nchar s[] = \"abc\";\ns[1] = '\\0';\nprintf(\"%zu\", strlen(s));",
  "options": [
   "3",
   "1",
   "2",
   "0"
  ],
  "correctIndex": 1,
  "explanation": "strlen stops at the first null byte, which is now at index 1, so the length is 1."
 },
 {
  "id": 205,
  "category": "dsa-core",
  "q": "On a typical 64-bit system with 4-byte int, what is printed?\n\nint *p = malloc(10 * sizeof(int));\nprintf(\"%zu\", sizeof(p) / sizeof(p[0]));",
  "options": [
   "10",
   "1",
   "2",
   "8"
  ],
  "correctIndex": 2,
  "explanation": "sizeof(p) is the pointer size (8), not the allocated block, so 8/4 = 2."
 },
 {
  "id": 206,
  "category": "dsa-core",
  "q": "Which approach removes duplicates from a sorted array in place in O(n) time and O(1) extra space?",
  "options": [
   "Two pointers: a fast one scans, a slow one writes the next unique value",
   "Insert each element into a hash set and copy back",
   "Sort the array again, then scan",
   "Nested loops that shift elements left on every duplicate"
  ],
  "correctIndex": 0,
  "explanation": "Duplicates are adjacent in a sorted array, so a read pointer and a write pointer solve it in one pass."
 },
 {
  "id": 207,
  "category": "dsa-core",
  "q": "Which technique detects a cycle in a singly linked list using O(1) extra space?",
  "options": [
   "Store every visited node address in a hash set",
   "Reverse the list and compare the head",
   "Count the nodes and compare with the array length",
   "Floyd's tortoise and hare: slow moves 1 step, fast moves 2"
  ],
  "correctIndex": 3,
  "explanation": "If a cycle exists, the fast pointer eventually meets the slow one, using O(n) time and O(1) space."
 },
 {
  "id": 208,
  "category": "dsa-core",
  "q": "What is the output?\n\nint a[] = {5, 10, 15};\nint *p = a;\nint x = *p++;\nprintf(\"%d %d\", x, *p);",
  "options": [
   "5 10",
   "5 5",
   "10 10",
   "10 15"
  ],
  "correctIndex": 0,
  "explanation": "*p++ yields 5 and then advances p, so *p is 10."
 },
 {
  "id": 209,
  "category": "dsa-core",
  "q": "What is the time complexity of this loop, assuming strlen is not hoisted?\n\nfor (i = 0; i < strlen(s); i++) s[i] = toupper(s[i]);",
  "options": [
   "O(n)",
   "O(log n)",
   "O(n^2)",
   "O(1)"
  ],
  "correctIndex": 2,
  "explanation": "strlen scans the whole string on each of the n iterations, giving O(n^2)."
 },
 {
  "id": 210,
  "category": "dsa-core",
  "q": "For an unsorted int array, what is the best way to find two numbers summing to a target in expected O(n) time?",
  "options": [
   "Sort and use two pointers, which is O(n) overall",
   "Nested loops checking all pairs",
   "Binary search on the unsorted array",
   "One pass with a hash table storing seen values and checking target - x"
  ],
  "correctIndex": 3,
  "explanation": "A hash table gives O(1) expected lookups, so one pass costs O(n) time and O(n) space. Sorting would cost O(n log n)."
 },
 {
  "id": 211,
  "category": "dsa-core",
  "q": "What is the output?\n\nchar a[] = \"ab\";\nchar b[] = \"ab\";\nprintf(\"%d\", a == b);",
  "options": [
   "1",
   "0",
   "Compilation error",
   "Undefined behavior"
  ],
  "correctIndex": 1,
  "explanation": "Comparing array names compares their addresses, and the two distinct arrays have different addresses, so the result is 0."
 },
 {
  "id": 212,
  "category": "dsa-core",
  "q": "How can an array containing only 0s, 1s and 2s be sorted in one pass with O(1) extra space?",
  "options": [
   "Dutch national flag algorithm with low, mid and high pointers",
   "Merge sort",
   "Counting sort with an auxiliary copy of the array",
   "Build a min-heap and extract elements"
  ],
  "correctIndex": 0,
  "explanation": "Three pointers partition the array into 0s, 1s and 2s in a single O(n) pass."
 },
 {
  "id": 213,
  "category": "dsa-core",
  "q": "With 4-byte int, what does this print?\n\nint a[3][3];\nint (*p)[3] = a;\nprintf(\"%zu\", sizeof(*p));",
  "options": [
   "4",
   "8",
   "12",
   "36"
  ],
  "correctIndex": 2,
  "explanation": "p points to an array of 3 ints, so *p is one row of 12 bytes."
 },
 {
  "id": 214,
  "category": "dsa-core",
  "q": "Which algorithm finds the majority element (> n/2 occurrences) in an array in O(n) time and O(1) space?",
  "options": [
   "Sorting and picking the middle element",
   "Hash map of counts",
   "Nested loop counting each element",
   "Boyer-Moore voting algorithm"
  ],
  "correctIndex": 3,
  "explanation": "Boyer-Moore keeps a candidate and a counter in one pass, using constant space. Sorting costs O(n log n), and a hash map uses O(n) space."
 },
 {
  "id": 215,
  "category": "dsa-core",
  "q": "In C11, what is the state of d after this code runs?\n\nchar d[4];\nstrncpy(d, \"abcd\", 4);",
  "options": [
   "d holds \"abcd\" and strncpy appends a terminating '\\0' automatically",
   "d holds the characters 'a','b','c','d' with no terminating '\\0', so reading d as a string is undefined behavior",
   "strncpy fails and returns NULL because the source is too long for d",
   "d holds \"abc\" followed by '\\0', since strncpy always reserves room for the terminator"
  ],
  "correctIndex": 1,
  "explanation": "strncpy copies at most n characters and only pads with '\\0' if the source is shorter than n; here the source length equals n, so no terminator is written."
 },
 {
  "id": 216,
  "category": "dsa-adv",
  "q": "Inorder traversal of a Binary Search Tree (BST) visits the keys in which order?",
  "options": [
   "Descending order",
   "Ascending sorted order",
   "Level by level",
   "Random order depending on insertion"
  ],
  "correctIndex": 1,
  "explanation": "Inorder visits left, node, right, which gives keys in ascending order for a BST."
 },
 {
  "id": 217,
  "category": "dsa-adv",
  "q": "What is the maximum number of nodes in a binary tree of height h, where a single-node tree has height 0?",
  "options": [
   "2^h",
   "2^h - 1",
   "2^(h+1) - 1",
   "h^2 + 1"
  ],
  "correctIndex": 2,
  "explanation": "Each level i holds at most 2^i nodes, so the sum for i = 0..h is 2^(h+1) - 1."
 },
 {
  "id": 218,
  "category": "dsa-adv",
  "q": "int h(Node*r){if(!r)return 0;int a=h(r->l),b=h(r->r);return 1+(a>b?a:b);}\nTree: 1 has children 2,3; 2 has left child 4. What is h(root)?",
  "options": [
   "2",
   "4",
   "3",
   "5"
  ],
  "correctIndex": 2,
  "explanation": "The longest path is 1->2->4, which has 3 nodes, so h returns 3."
 },
 {
  "id": 219,
  "category": "dsa-adv",
  "q": "What is the minimum number of edit operations (insert, delete, replace) to convert \"kitten\" to \"sitting\"?",
  "options": [
   "2",
   "3",
   "4",
   "5"
  ],
  "correctIndex": 1,
  "explanation": "Replace k->s, replace e->i, insert g: 3 operations (Levenshtein distance)."
 },
 {
  "id": 220,
  "category": "dsa-adv",
  "q": "What is the time complexity of BFS on a graph with V vertices and E edges stored as an adjacency list?",
  "options": [
   "O(V*E)",
   "O(V^2)",
   "O(E log V)",
   "O(V + E)"
  ],
  "correctIndex": 3,
  "explanation": "Each vertex is enqueued once and each adjacency list is scanned once, giving O(V+E)."
 },
 {
  "id": 221,
  "category": "dsa-adv",
  "q": "How much space does an adjacency matrix need for a graph with V vertices?",
  "options": [
   "O(V + E)",
   "O(V)",
   "O(V^2)",
   "O(E^2)"
  ],
  "correctIndex": 2,
  "explanation": "A V x V matrix is stored regardless of how many edges exist."
 },
 {
  "id": 222,
  "category": "dsa-adv",
  "q": "Which algorithm correctly finds single-source shortest paths when edges may have negative weights (no negative cycle)?",
  "options": [
   "Dijkstra's algorithm",
   "Bellman-Ford algorithm",
   "Prim's algorithm",
   "Kruskal's algorithm"
  ],
  "correctIndex": 1,
  "explanation": "Bellman-Ford relaxes all edges V-1 times and handles negative weights; Dijkstra's greedy choice can fail."
 },
 {
  "id": 223,
  "category": "dsa-adv",
  "q": "What is the time complexity of computing the nth Fibonacci number with memoization (top-down DP)?",
  "options": [
   "O(2^n)",
   "O(n^2)",
   "O(log n) always",
   "O(n)"
  ],
  "correctIndex": 3,
  "explanation": "Each subproblem fib(0..n) is computed once in O(1), so the total is O(n)."
 },
 {
  "id": 224,
  "category": "dsa-adv",
  "q": "int dp[6]={1};\nint c[]={1,2,5};\nfor(int k=0;k<3;k++)for(int i=c[k];i<=5;i++)dp[i]+=dp[i-c[k]];\nprintf(\"%d\",dp[5]);\nWhat is printed?",
  "options": [
   "3",
   "5",
   "6",
   "4"
  ],
  "correctIndex": 3,
  "explanation": "This counts coin combinations for 5: {5}, {2,2,1}, {2,1,1,1}, {1x5} = 4."
 },
 {
  "id": 225,
  "category": "dsa-adv",
  "q": "What is the length of the Longest Common Subsequence of \"AGGTAB\" and \"GXTXAYB\"?",
  "options": [
   "3",
   "4",
   "5",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "The LCS is \"GTAB\", which has length 4."
 },
 {
  "id": 226,
  "category": "dsa-adv",
  "q": "A spanning tree of a connected graph with V vertices has exactly how many edges?",
  "options": [
   "V - 1",
   "V",
   "V + 1",
   "E - 1"
  ],
  "correctIndex": 0,
  "explanation": "A tree on V vertices is connected and acyclic, so it has exactly V-1 edges."
 },
 {
  "id": 227,
  "category": "dsa-adv",
  "q": "Topological ordering of vertices is possible only for which kind of graph?",
  "options": [
   "Any undirected graph",
   "Directed graph with cycles",
   "Directed Acyclic Graph (DAG)",
   "Complete graph"
  ],
  "correctIndex": 2,
  "explanation": "A cycle makes a valid linear order impossible, so only DAGs have topological orders."
 },
 {
  "id": 228,
  "category": "dsa-adv",
  "q": "What is the minimum number of nodes in an AVL tree of height 3 (single node has height 0)?",
  "options": [
   "7",
   "8",
   "6",
   "10"
  ],
  "correctIndex": 0,
  "explanation": "N(h) = N(h-1) + N(h-2) + 1 with N(0)=1, N(1)=2 gives N(2)=4 and N(3)=7."
 },
 {
  "id": 229,
  "category": "dsa-adv",
  "q": "int d[3][3];\nfor(int i=0;i<3;i++)for(int j=0;j<3;j++)\n d[i][j]=(i==0||j==0)?1:d[i-1][j]+d[i][j-1];\nprintf(\"%d\",d[2][2]);\nWhat is printed?",
  "options": [
   "4",
   "6",
   "9",
   "8"
  ],
  "correctIndex": 1,
  "explanation": "This counts right/down grid paths in a 3x3 grid: C(4,2) = 6."
 },
 {
  "id": 230,
  "category": "dsa-adv",
  "q": "Which data structure does Kruskal's MST algorithm use to avoid forming cycles?",
  "options": [
   "Disjoint Set Union (Union-Find)",
   "Min-heap of vertices only",
   "Stack",
   "Adjacency matrix"
  ],
  "correctIndex": 0,
  "explanation": "Union-Find checks whether an edge's endpoints are already connected before adding it."
 },
 {
  "id": 231,
  "category": "dsa-adv",
  "q": "Which approach detects a cycle in a directed graph in O(V+E)?",
  "options": [
   "BFS using only a visited array",
   "DFS tracking vertices on the current recursion stack",
   "Sorting the edges by weight",
   "Counting the edges"
  ],
  "correctIndex": 1,
  "explanation": "A back edge to a vertex still on the recursion stack indicates a directed cycle."
 },
 {
  "id": 232,
  "category": "dsa-adv",
  "q": "Which pair of traversals does NOT always identify a binary tree uniquely?",
  "options": [
   "Preorder + Inorder",
   "Postorder + Inorder",
   "Level order + Inorder",
   "Preorder + Postorder"
  ],
  "correctIndex": 3,
  "explanation": "Preorder + postorder cannot distinguish a lone left child from a lone right child, so the tree may not be unique."
 },
 {
  "id": 233,
  "category": "dsa-adv",
  "q": "What is the time complexity of the standard 0/1 knapsack DP with n items and capacity W?",
  "options": [
   "O(n + W)",
   "O(2^n)",
   "O(n log W)",
   "O(n * W)"
  ],
  "correctIndex": 3,
  "explanation": "The table has n*W states, each filled in O(1); this is pseudo-polynomial time."
 },
 {
  "id": 234,
  "category": "dsa-adv",
  "q": "Keys 5,3,8,1,4 are inserted into an empty BST in that order. What is the preorder traversal?",
  "options": [
   "1 3 4 5 8",
   "5 3 1 4 8",
   "5 3 8 1 4",
   "1 4 3 8 5"
  ],
  "correctIndex": 1,
  "explanation": "Root 5, left subtree 3 (children 1,4), right child 8; preorder is 5 3 1 4 8."
 },
 {
  "id": 235,
  "category": "dsa-adv",
  "q": "How many structurally distinct BSTs can be built using keys 1, 2, 3 and 4?",
  "options": [
   "10",
   "12",
   "14",
   "24"
  ],
  "correctIndex": 2,
  "explanation": "The count is the Catalan number C4 = (1/5)*C(8,4) = 14."
 },
 {
  "id": 236,
  "category": "dsa-adv",
  "q": "struct Node{int v;struct Node*l,*r;};\nint f(struct Node*t){if(!t)return 0;if(!t->l&&!t->r)return 1;return f(t->l)+f(t->r);}\nTree: 1(2(4,5),3(-,6)). What does f(root) return?",
  "options": [
   "2",
   "6",
   "3",
   "4"
  ],
  "correctIndex": 2,
  "explanation": "f counts leaf nodes. The leaves are 4, 5 and 6, so the result is 3."
 },
 {
  "id": 237,
  "category": "dsa-adv",
  "q": "What is the time complexity of Dijkstra's algorithm on a graph with V vertices and E edges using an adjacency list and a binary min-heap?",
  "options": [
   "O((V+E) log V)",
   "O(V^2 log V)",
   "O(V*E)",
   "O(E + V)"
  ],
  "correctIndex": 0,
  "explanation": "Each edge relaxation may do a heap push or decrease-key costing O(log V), giving O((V+E) log V)."
 },
 {
  "id": 238,
  "category": "dsa-adv",
  "q": "int a[]={5,1,6,2,7,3},dp[6],m=0;\nfor(int i=0;i<6;i++){dp[i]=1;for(int j=0;j<i;j++)if(a[j]<a[i]&&dp[j]+1>dp[i])dp[i]=dp[j]+1;if(dp[i]>m)m=dp[i];}\nprintf(\"%d\",m);\nWhat is printed?",
  "options": [
   "4",
   "3",
   "2",
   "6"
  ],
  "correctIndex": 1,
  "explanation": "This is the O(n^2) LIS DP. The longest increasing subsequences, such as 1,2,3 or 5,6,7, have length 3."
 },
 {
  "id": 239,
  "category": "dsa-adv",
  "q": "In a DFS of an undirected graph, every non-tree edge connects a vertex to which kind of vertex?",
  "options": [
   "A sibling in a different subtree",
   "A vertex in an unrelated subtree",
   "A child that is not its DFS child only",
   "One of its ancestors or descendants"
  ],
  "correctIndex": 3,
  "explanation": "Undirected DFS has no cross edges, so every non-tree edge is a back edge between a vertex and its ancestor or descendant."
 },
 {
  "id": 240,
  "category": "dsa-adv",
  "q": "In the triple-loop Floyd-Warshall algorithm for all-pairs shortest paths, which variable must be the outermost loop?",
  "options": [
   "The source vertex i",
   "The destination vertex j",
   "The intermediate vertex k",
   "Any order works equally"
  ],
  "correctIndex": 2,
  "explanation": "The DP state is 'paths using only the first k vertices as intermediates', so k must be the outermost loop."
 },
 {
  "id": 241,
  "category": "networking",
  "q": "Which layer of the OSI model is primarily responsible for logical addressing and routing of packets across different networks?",
  "options": [
   "Data Link layer",
   "Network layer",
   "Transport layer",
   "Session layer"
  ],
  "correctIndex": 1,
  "explanation": "The Network layer (Layer 3) handles IP addressing and routing between networks."
 },
 {
  "id": 242,
  "category": "networking",
  "q": "Which well-known TCP port is used by default for HTTPS traffic?",
  "options": [
   "80",
   "8080",
   "443",
   "21"
  ],
  "correctIndex": 2,
  "explanation": "HTTPS uses TCP port 443 by default; 80 is HTTP and 21 is FTP control."
 },
 {
  "id": 243,
  "category": "networking",
  "q": "How many usable host addresses are available in the subnet 192.168.10.0/26?",
  "options": [
   "62",
   "64",
   "30",
   "126"
  ],
  "correctIndex": 0,
  "explanation": "A /26 leaves 6 host bits: 2^6 = 64 addresses, minus network and broadcast = 62 usable."
 },
 {
  "id": 244,
  "category": "networking",
  "q": "In C on Linux, which call correctly creates a UDP socket over IPv4?",
  "options": [
   "socket(AF_INET, SOCK_STREAM, 0)",
   "socket(AF_INET, SOCK_RAW, UDP)",
   "socket(AF_UNIX, SOCK_DGRAM, TCP)",
   "socket(AF_INET, SOCK_DGRAM, 0)"
  ],
  "correctIndex": 3,
  "explanation": "SOCK_DGRAM with AF_INET (protocol 0 defaults to UDP) creates an IPv4 UDP socket."
 },
 {
  "id": 245,
  "category": "networking",
  "q": "On a little-endian x86 machine, what does this print?\n#include <arpa/inet.h>\nuint16_t x = 0x1234;\nprintf(\"%x\", htons(x));",
  "options": [
   "1234",
   "3412",
   "4321",
   "12"
  ],
  "correctIndex": 1,
  "explanation": "htons converts to big-endian network order; on little-endian hosts it swaps the bytes, giving 0x3412."
 },
 {
  "id": 246,
  "category": "networking",
  "q": "What is the correct sequence of segments in the TCP connection establishment (three-way handshake)?",
  "options": [
   "SYN, SYN-ACK, ACK",
   "SYN, ACK, SYN-ACK",
   "SYN, SYN, ACK",
   "ACK, SYN, SYN-ACK"
  ],
  "correctIndex": 0,
  "explanation": "Client sends SYN, server replies SYN-ACK, and client completes with ACK."
 },
 {
  "id": 247,
  "category": "networking",
  "q": "Why does the side that actively closes a TCP connection enter the TIME_WAIT state?",
  "options": [
   "To wait for the peer to send its own FIN",
   "To free the port immediately for reuse",
   "To retransmit the last ACK if lost and let delayed segments expire (2*MSL)",
   "To renegotiate the window size before closing"
  ],
  "correctIndex": 2,
  "explanation": "TIME_WAIT lasts 2*MSL so a lost final ACK can be resent and old duplicate segments die out."
 },
 {
  "id": 248,
  "category": "networking",
  "q": "What is the correct order of system calls for a basic blocking TCP server in C?",
  "options": [
   "socket, listen, bind, accept",
   "socket, connect, listen, accept",
   "bind, socket, accept, listen",
   "socket, bind, listen, accept"
  ],
  "correctIndex": 3,
  "explanation": "Create the socket, bind it to an address/port, mark it passive with listen, then accept connections."
 },
 {
  "id": 249,
  "category": "networking",
  "q": "A Selective Repeat ARQ protocol uses 3-bit sequence numbers. What is the maximum sender window size that works correctly?",
  "options": [
   "2",
   "4",
   "7",
   "8"
  ],
  "correctIndex": 1,
  "explanation": "Selective Repeat requires window size <= 2^(k-1) = 4 to avoid ambiguity between old and new frames."
 },
 {
  "id": 250,
  "category": "networking",
  "q": "In a C TCP client, recv(fd, buf, sizeof buf, 0) returns 0. What does this indicate?",
  "options": [
   "A timeout occurred and no data arrived",
   "The receive buffer is currently empty",
   "The peer performed an orderly shutdown (sent FIN)",
   "A non-blocking socket would block"
  ],
  "correctIndex": 2,
  "explanation": "recv returning 0 on a stream socket means the peer closed the connection; errors return -1 and timeouts/would-block set errno."
 }
];
export const CATEGORIES = [
 {
  "id": "c-core",
  "label": "C Fundamentals",
  "count": 40
 },
 {
  "id": "pointers",
  "label": "Pointers & Memory",
  "count": 35
 },
 {
  "id": "c-arrays",
  "label": "Arrays & Strings in C",
  "count": 25
 },
 {
  "id": "structs-files",
  "label": "Structs, Unions & File I/O",
  "count": 20
 },
 {
  "id": "preproc",
  "label": "Preprocessor & Compilation",
  "count": 15
 },
 {
  "id": "c-funcs",
  "label": "Functions & Recursion",
  "count": 15
 },
 {
  "id": "systems",
  "label": "OS & Systems Programming",
  "count": 15
 },
 {
  "id": "sql",
  "label": "SQL & Database",
  "count": 20
 },
 {
  "id": "dsa-core",
  "label": "DSA - Arrays/Strings/Lists",
  "count": 30
 },
 {
  "id": "dsa-adv",
  "label": "DSA - Trees/Graphs/DP",
  "count": 25
 },
 {
  "id": "networking",
  "label": "Computer Networks",
  "count": 10
 }
];
